/* eslint-disable prettier/prettier */
// This file was automatically generated by 'dev generate graphql' and should not be edited.
import {ActionMethod, ActionOrigin, AllowedTimezone, BenchlingAppSubscriptions, NotificationOptOutPreferenceKeys, PipelineStepType, ProcessDisplayNameAssays, ProcessDisplayNameProcesses, ProcessDisplayNameRecipes, ProcessSingletonTaskSchemaName, ValidationErrorLabel} from './graphqlGlobalTypes';

export const APP_SUBSCRIPTION_TO_MESSAGETYPE: Record<BenchlingAppSubscriptions, string> = {
  [BenchlingAppSubscriptions.V2_BETA_CANVAS_CREATED]: 'v2-beta.canvas.created',
  [BenchlingAppSubscriptions.V2_CANVAS_CREATED]: 'v2.canvas.created',
  [BenchlingAppSubscriptions.V2_CANVAS_USER_INTERACTED]: 'v2.canvas.userInteracted',
  [BenchlingAppSubscriptions.V2_CANVAS_INITIALIZED]: 'v2.canvas.initialized',
  [BenchlingAppSubscriptions.V2_APP_ACTIVATE_REQUESTED]: 'v2.app.activateRequested',
  [BenchlingAppSubscriptions.V2_APP_DEACTIVATED]: 'v2.app.deactivated',
  [BenchlingAppSubscriptions.V2_APP_INSTALLED]: 'v2.app.installed',
  [BenchlingAppSubscriptions.V2_BETA_APP_CONFIGURATION_UPDATED]: 'v2-beta.app.configuration.updated',
  [BenchlingAppSubscriptions.V2_ASSAY_RUN_CREATED]: 'v2.assayRun.created',
  [BenchlingAppSubscriptions.V2_ASSAY_RUN_UPDATED_FIELDS]: 'v2.assayRun.updated.fields',
  [BenchlingAppSubscriptions.V2_ENTITY_REGISTERED]: 'v2.entity.registered',
  [BenchlingAppSubscriptions.V2_ENTRY_CREATED]: 'v2.entry.created',
  [BenchlingAppSubscriptions.V2_ENTRY_UPDATED_FIELDS]: 'v2.entry.updated.fields',
  [BenchlingAppSubscriptions.V2_ENTRY_UPDATED_REVIEW_RECORD]: 'v2.entry.updated.reviewRecord',
  [BenchlingAppSubscriptions.V2_REQUEST_CREATED]: 'v2.request.created',
  [BenchlingAppSubscriptions.V2_REQUEST_UPDATED_FIELDS]: 'v2.request.updated.fields',
  [BenchlingAppSubscriptions.V2_REQUEST_UPDATED_STATUS]: 'v2.request.updated.status',
  [BenchlingAppSubscriptions.V2_WORKFLOW_TASK_GROUP_CREATED]: 'v2.workflowTaskGroup.created',
  [BenchlingAppSubscriptions.V2_WORKFLOW_TASK_GROUP_MAPPING_COMPLETED]: 'v2.workflowTaskGroup.mappingCompleted',
  [BenchlingAppSubscriptions.V2_WORKFLOW_TASK_GROUP_UPDATED_WATCHERS]: 'v2.workflowTaskGroup.updated.watchers',
  [BenchlingAppSubscriptions.V2_WORKFLOW_TASK_CREATED]: 'v2.workflowTask.created',
  [BenchlingAppSubscriptions.V2_WORKFLOW_TASK_UPDATED_ASSIGNEE]: 'v2.workflowTask.updated.assignee',
  [BenchlingAppSubscriptions.V2_WORKFLOW_TASK_UPDATED_SCHEDULED_ON]: 'v2.workflowTask.updated.scheduledOn',
  [BenchlingAppSubscriptions.V2_WORKFLOW_TASK_UPDATED_STATUS]: 'v2.workflowTask.updated.status',
  [BenchlingAppSubscriptions.V2_WORKFLOW_TASK_UPDATED_FIELDS]: 'v2.workflowTask.updated.fields',
  [BenchlingAppSubscriptions.V2_WORKFLOW_OUTPUT_CREATED]: 'v2.workflowOutput.created',
  [BenchlingAppSubscriptions.V2_WORKFLOW_OUTPUT_UPDATED_FIELDS]: 'v2.workflowOutput.updated.fields',
  [BenchlingAppSubscriptions.V3_ENTRY_CREATED]: 'v3.entry.created',
  [BenchlingAppSubscriptions.V3_RUN_CREATED]: 'v3.run.created',
  [BenchlingAppSubscriptions.V3_PROJECT_CREATED]: 'v3.project.created',
  [BenchlingAppSubscriptions.V3_PROJECT_UPDATED]: 'v3.project.updated',
  [BenchlingAppSubscriptions.V3_CUSTOM_ENTITY_CREATED]: 'v3.customEntity.created',
  [BenchlingAppSubscriptions.V3_CUSTOM_ENTITY_UPDATED]: 'v3.customEntity.updated',
  [BenchlingAppSubscriptions.V3_DNA_OLIGO_CREATED]: 'v3.dnaOligo.created',
  [BenchlingAppSubscriptions.V3_DNA_OLIGO_UPDATED]: 'v3.dnaOligo.updated',
  [BenchlingAppSubscriptions.V3_DNA_SEQUENCE_CREATED]: 'v3.dnaSequence.created',
  [BenchlingAppSubscriptions.V3_DNA_SEQUENCE_UPDATED]: 'v3.dnaSequence.updated',
  [BenchlingAppSubscriptions.V3_RNA_OLIGO_CREATED]: 'v3.rnaOligo.created',
  [BenchlingAppSubscriptions.V3_RNA_OLIGO_UPDATED]: 'v3.rnaOligo.updated',
  [BenchlingAppSubscriptions.V3_RNA_SEQUENCE_CREATED]: 'v3.rnaSequence.created',
  [BenchlingAppSubscriptions.V3_RNA_SEQUENCE_UPDATED]: 'v3.rnaSequence.updated',
  [BenchlingAppSubscriptions.V2_AUTOMATION_FILE_TRANSFORM_UPDATED_STATUS_RUNNING]: 'v2.automationFileTransform.updated.status.running',
  [BenchlingAppSubscriptions.V2_AUTOMATION_FILE_TRANSFORM_UPDATED_STATUS_PENDING]: 'v2.automationFileTransform.updated.status.pending',
  [BenchlingAppSubscriptions.V2_AUTOMATION_FILE_TRANSFORM_UPDATED_STATUS_SUCCEEDED]: 'v2.automationFileTransform.updated.status.succeeded',
  [BenchlingAppSubscriptions.V2_AUTOMATION_FILE_TRANSFORM_UPDATED_STATUS_FAILED]: 'v2.automationFileTransform.updated.status.failed',
};
export const VALIDATION_ERROR_LABEL: Record<ValidationErrorLabel, string> = {
  [ValidationErrorLabel.OVER_CAPACITY]: 'Over capacity',
  [ValidationErrorLabel.ITEM_TYPES_DISALLOWED]: 'Invalid item types stored',
  [ValidationErrorLabel.NON_LOCATION_ITEMS_DISALLOWED]: 'Non-location items stored',
  [ValidationErrorLabel.INVALID_VALUE]: 'Invalid value',
  [ValidationErrorLabel.INVALID_LINK]: 'Invalid link',
  [ValidationErrorLabel.INVALID_MULTIPLE_LINK]: 'Multiple links not allowed',
  [ValidationErrorLabel.MISSING_REQUIRED]: 'Required value',
  [ValidationErrorLabel.CONSTRAINT_VIOLATION_ACROSS_INTERFACE]: 'Constraint violation across different tag schemas under the same interface constraint',
  [ValidationErrorLabel.CONSTRAINT_VIOLATION]: 'Constraint violation',
  [ValidationErrorLabel.UNIQUE_CONSTRAINT_LOCK]: 'Conflict with concurrent operation',
};
export const NOTIFICATION_OPT_OUT_PREFERENCE_KEYS: Record<NotificationOptOutPreferenceKeys, string> = {
  [NotificationOptOutPreferenceKeys.ORG_NOTIFICATION_OPT_OUT]: 'ORG_NOTIFICATION_OPT_OUT',
  [NotificationOptOutPreferenceKeys.PROCESSES_NOTIFICATION_OPT_OUT]: 'PROCESSES_NOTIFICATION_OPT_OUT',
  [NotificationOptOutPreferenceKeys.REQUESTS_V2_NOTIFICATION_OPT_OUT]: 'REQUESTS_V2_NOTIFICATION_OPT_OUT',
  [NotificationOptOutPreferenceKeys.STUDIES_NOTIFICATION_OPT_OUT]: 'STUDIES_NOTIFICATION_OPT_OUT',
};
export const STEP_TYPE_TO_USER_FACING_NAME: Record<PipelineStepType, string> = {
  [PipelineStepType.AGGREGATE_DATASET]: 'Aggregate table',
  [PipelineStepType.ANOVA]: 'ANOVA',
  [PipelineStepType.BIN_DATA]: 'Bin data',
  [PipelineStepType.BOLTZ2]: 'Boltz-2 protein structure prediction',
  [PipelineStepType.BOLTZGEN]: 'BoltzGen',
  [PipelineStepType.BOLTZGEN_SUCCESS]: 'BoltzGen Success',
  [PipelineStepType.CHAI1]: 'Chai1 protein structure prediction',
  [PipelineStepType.CHART_VIEW]: 'Chart',
  [PipelineStepType.COMPUTED_COLUMN]: 'Add computed column',
  [PipelineStepType.CONNECTION_DATA_DATASET]: 'Create table from connection',
  [PipelineStepType.CONVERT_ASM_TO_CSV]: 'Convert ASM files to CSV files',
  [PipelineStepType.CONVERT_FILE_TO_DATASET_WITH_DATA_ENTRY_ASSISTANT]: 'Convert file to dataset with Data Entry Assistant',
  [PipelineStepType.CONVERT_JSON_TO_DATASET]: 'Convert JSON file to dataset',
  [PipelineStepType.CONVERT_OPENFOLD2_OUTPUT]: 'Convert OpenFold2 Job Output To Structure Prediction Output API Format',
  [PipelineStepType.CONVERT_TO_ASM]: 'Convert instrument files to ASM files',
  [PipelineStepType.CREATE_DATASET_FROM_FILE]: 'Convert CSV files to dataset',
  [PipelineStepType.CREATE_METERING_USAGE_CHART]: 'Create metering usage chart',
  [PipelineStepType.CREATE_PROCEDURE_DATASET]: 'Create table from study data',
  [PipelineStepType.DATA_CATALOG_DATASET]: 'Create table from dataset',
  [PipelineStepType.DATA_CATALOG_FILE]: 'Import file from data catalog',
  [PipelineStepType.DATA_CATALOG_FILES]: 'Import files from data catalog',
  [PipelineStepType.DATASET_VIEW]: 'View',
  [PipelineStepType.DEFINE_TEMPLATE_VARIABLES]: 'Define template variables',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_BOOTSTRAP]: 'Experiment optimization bootstrap',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_CLEAN_DATA]: 'Experiment optimization clean data',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_EXPLANATION]: 'Experiment optimization explanation',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE]: 'Experiment optimization generate search space',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY]: 'Experiment optimization posterior summary',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_RECOMMENDATION]: 'Experiment optimization recommendation',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_TRAINING]: 'Experiment optimization training',
  [PipelineStepType.EXPLORATORY_DATA_ANALYSIS]: 'Exploratory data analysis',
  [PipelineStepType.EXPORT_DATA_CATALOG_DATASET]: 'Export table as dataset',
  [PipelineStepType.EXPORT_DATA_CATALOG_FILE]: 'Export file to the data catalog',
  [PipelineStepType.EXTRACT_DATA_FRAME_VALUE]: 'Extract table value',
  [PipelineStepType.EXTRACT_OR_REMOVE_LINES]: 'Extract or remove lines from files',
  [PipelineStepType.FILTER_DATASET]: 'Filter table',
  [PipelineStepType.FIND_AND_REPLACE]: 'Find and replace text',
  [PipelineStepType.FLAG_ROWS]: 'Flag rows',
  [PipelineStepType.GENERATE_BOLTZ_YAML]: 'Generate an input yaml file for configuring a boltz execution',
  [PipelineStepType.GENERATE_BOLTZGEN_YAML]: 'Generate BoltzGen YAML',
  [PipelineStepType.GENERATE_FASTA]: 'Generate FASTA from Structure Prediction Run',
  [PipelineStepType.GENERATE_OPENFOLD2_JSON]: 'Generate OpenFold2 Job Input JSON File',
  [PipelineStepType.HIDE_COLUMNS]: 'Hide columns',
  [PipelineStepType.IMPORT_SCRATCH_FILE]: 'Import scratch file',
  [PipelineStepType.INITIALIZE_DATASET]: 'Create table from Insights block',
  [PipelineStepType.INTERPOLATE_MARKDOWN]: 'Create markdown with values from data',
  [PipelineStepType.JOIN]: 'Join tables',
  [PipelineStepType.LAYOUT]: 'Layout',
  [PipelineStepType.LOOK_UP]: 'Look up',
  [PipelineStepType.MAP_COLUMNS]: 'Map columns',
  [PipelineStepType.MAP_JSON_TO_DATASETS_AND_FILES]: 'Convert JSON file to datasets and JSON metadata files',
  [PipelineStepType.NOTEBOOK_TABLE_DATASET]: 'Create table from Notebook table',
  [PipelineStepType.OPENFOLD2]: 'Openfold2 protein structure prediction',
  [PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION]: 'Parameter optimization configuration',
  [PipelineStepType.PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION]: 'Parameter optimization setup',
  [PipelineStepType.PARAMETER_OPTIMIZATION_MODELING]: 'Parameter optimization results',
  [PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION]: 'Parameter optimization predictions',
  [PipelineStepType.PIVOT_DATASET]: 'Pivot table',
  [PipelineStepType.PLATE_SCHEMA_DATASET]: 'Create table from Plate Schema',
  [PipelineStepType.PROCEDURE_RUN_DATA_FRAMES]: 'Create tables from experiment run',
  [PipelineStepType.PROMOTE_DATASET]: 'Promote view',
  [PipelineStepType.REGISTRY_SCHEMA_DATASET]: 'Create table from Registry Schemas',
  [PipelineStepType.REGRESSION]: 'Calculate regression',
  [PipelineStepType.REGRESSION_INTERPOLATION]: 'Calculate interpolation',
  [PipelineStepType.RENAME_COLUMNS]: 'Rename columns',
  [PipelineStepType.REORDER_COLUMNS]: 'Reorder columns',
  [PipelineStepType.RETYPE_COLUMNS]: 'Convert column formats',
  [PipelineStepType.RUN_HIGHRES_PROTOCOL]: 'Run HighRes protocol',
  [PipelineStepType.SAVE_STRUCTURE_PREDICTION]: 'Save structure prediction',
  [PipelineStepType.SAVE_TO_RESULTS]: 'Save to Results',
  [PipelineStepType.SEND_TO_CONNECTION]: 'Send to connection',
  [PipelineStepType.SEND_TO_DOCUMENT]: 'Send outputs',
  [PipelineStepType.SORT_COLUMNS]: 'Sort',
  [PipelineStepType.T_TEST]: 'T-test',
  [PipelineStepType.TABLE_VIEW]: 'Table view',
  [PipelineStepType.TEMPLATE_INPUT]: 'Template input',
  [PipelineStepType.TEST_ALL_CONFIGS]: 'Test all config types',
  [PipelineStepType.THIRD_PARTY]: 'Import/export',
  [PipelineStepType.UNION_DATASETS]: 'Union tables',
  [PipelineStepType.UNPIVOT_DATASET]: 'Unpivot table',
  [PipelineStepType.UPLOAD_CSV_DATASET]: 'Create table from uploaded CSV',
  [PipelineStepType.USER_DEFINED_FUNCTION]: 'Custom code',
  [PipelineStepType.WINDOW_FUNCTIONS]: 'Add window functions',
};
export const STEP_TYPE_TO_ICON: Record<PipelineStepType, string | null> = {
  [PipelineStepType.AGGREGATE_DATASET]: null,
  [PipelineStepType.ANOVA]: null,
  [PipelineStepType.BIN_DATA]: null,
  [PipelineStepType.BOLTZ2]: null,
  [PipelineStepType.BOLTZGEN]: null,
  [PipelineStepType.BOLTZGEN_SUCCESS]: null,
  [PipelineStepType.CHAI1]: null,
  [PipelineStepType.CHART_VIEW]: 'chart-column',
  [PipelineStepType.COMPUTED_COLUMN]: 'function',
  [PipelineStepType.CONNECTION_DATA_DATASET]: 'connection',
  [PipelineStepType.CONVERT_ASM_TO_CSV]: null,
  [PipelineStepType.CONVERT_FILE_TO_DATASET_WITH_DATA_ENTRY_ASSISTANT]: null,
  [PipelineStepType.CONVERT_JSON_TO_DATASET]: null,
  [PipelineStepType.CONVERT_OPENFOLD2_OUTPUT]: null,
  [PipelineStepType.CONVERT_TO_ASM]: null,
  [PipelineStepType.CREATE_DATASET_FROM_FILE]: 'dataset',
  [PipelineStepType.CREATE_METERING_USAGE_CHART]: null,
  [PipelineStepType.CREATE_PROCEDURE_DATASET]: null,
  [PipelineStepType.DATA_CATALOG_DATASET]: 'dataset',
  [PipelineStepType.DATA_CATALOG_FILE]: 'paperclip',
  [PipelineStepType.DATA_CATALOG_FILES]: 'paperclip',
  [PipelineStepType.DATASET_VIEW]: null,
  [PipelineStepType.DEFINE_TEMPLATE_VARIABLES]: null,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_BOOTSTRAP]: null,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_CLEAN_DATA]: null,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_EXPLANATION]: null,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE]: null,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY]: null,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_RECOMMENDATION]: null,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_TRAINING]: null,
  [PipelineStepType.EXPLORATORY_DATA_ANALYSIS]: null,
  [PipelineStepType.EXPORT_DATA_CATALOG_DATASET]: 'dataset',
  [PipelineStepType.EXPORT_DATA_CATALOG_FILE]: null,
  [PipelineStepType.EXTRACT_DATA_FRAME_VALUE]: null,
  [PipelineStepType.EXTRACT_OR_REMOVE_LINES]: null,
  [PipelineStepType.FILTER_DATASET]: 'bars-filter',
  [PipelineStepType.FIND_AND_REPLACE]: null,
  [PipelineStepType.FLAG_ROWS]: 'flag',
  [PipelineStepType.GENERATE_BOLTZ_YAML]: null,
  [PipelineStepType.GENERATE_BOLTZGEN_YAML]: null,
  [PipelineStepType.GENERATE_FASTA]: null,
  [PipelineStepType.GENERATE_OPENFOLD2_JSON]: null,
  [PipelineStepType.HIDE_COLUMNS]: 'eye-slash',
  [PipelineStepType.IMPORT_SCRATCH_FILE]: null,
  [PipelineStepType.INITIALIZE_DATASET]: 'analytics_dashboard',
  [PipelineStepType.INTERPOLATE_MARKDOWN]: null,
  [PipelineStepType.JOIN]: 'merge',
  [PipelineStepType.LAYOUT]: null,
  [PipelineStepType.LOOK_UP]: 'square-list-magnifying-glass',
  [PipelineStepType.MAP_COLUMNS]: null,
  [PipelineStepType.MAP_JSON_TO_DATASETS_AND_FILES]: null,
  [PipelineStepType.NOTEBOOK_TABLE_DATASET]: null,
  [PipelineStepType.OPENFOLD2]: null,
  [PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION]: null,
  [PipelineStepType.PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION]: null,
  [PipelineStepType.PARAMETER_OPTIMIZATION_MODELING]: null,
  [PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION]: 'crystal-ball',
  [PipelineStepType.PIVOT_DATASET]: 'table-pivot',
  [PipelineStepType.PLATE_SCHEMA_DATASET]: 'plate',
  [PipelineStepType.PROCEDURE_RUN_DATA_FRAMES]: null,
  [PipelineStepType.PROMOTE_DATASET]: null,
  [PipelineStepType.REGISTRY_SCHEMA_DATASET]: 'registry',
  [PipelineStepType.REGRESSION]: 'chart-scatter',
  [PipelineStepType.REGRESSION_INTERPOLATION]: null,
  [PipelineStepType.RENAME_COLUMNS]: 'pen',
  [PipelineStepType.REORDER_COLUMNS]: null,
  [PipelineStepType.RETYPE_COLUMNS]: null,
  [PipelineStepType.RUN_HIGHRES_PROTOCOL]: 'robot',
  [PipelineStepType.SAVE_STRUCTURE_PREDICTION]: null,
  [PipelineStepType.SAVE_TO_RESULTS]: null,
  [PipelineStepType.SEND_TO_CONNECTION]: null,
  [PipelineStepType.SEND_TO_DOCUMENT]: 'paper-plane',
  [PipelineStepType.SORT_COLUMNS]: null,
  [PipelineStepType.T_TEST]: null,
  [PipelineStepType.TABLE_VIEW]: 'table',
  [PipelineStepType.TEMPLATE_INPUT]: null,
  [PipelineStepType.TEST_ALL_CONFIGS]: null,
  [PipelineStepType.THIRD_PARTY]: null,
  [PipelineStepType.UNION_DATASETS]: null,
  [PipelineStepType.UNPIVOT_DATASET]: 'table-pivot',
  [PipelineStepType.UPLOAD_CSV_DATASET]: 'upload',
  [PipelineStepType.USER_DEFINED_FUNCTION]: 'code',
  [PipelineStepType.WINDOW_FUNCTIONS]: null,
};
export const STEP_TYPE_TO_GROUPS: Record<PipelineStepType, Array<string>> = {
  [PipelineStepType.AGGREGATE_DATASET]: ['Transform'],
  [PipelineStepType.ANOVA]: ['Statistics'],
  [PipelineStepType.BIN_DATA]: ['Transform'],
  [PipelineStepType.BOLTZ2]: [],
  [PipelineStepType.BOLTZGEN]: [],
  [PipelineStepType.BOLTZGEN_SUCCESS]: [],
  [PipelineStepType.CHAI1]: [],
  [PipelineStepType.CHART_VIEW]: [],
  [PipelineStepType.COMPUTED_COLUMN]: ['Transform'],
  [PipelineStepType.CONNECTION_DATA_DATASET]: ['Create table'],
  [PipelineStepType.CONVERT_ASM_TO_CSV]: ['Connect'],
  [PipelineStepType.CONVERT_FILE_TO_DATASET_WITH_DATA_ENTRY_ASSISTANT]: ['AI tools'],
  [PipelineStepType.CONVERT_JSON_TO_DATASET]: ['Connect'],
  [PipelineStepType.CONVERT_OPENFOLD2_OUTPUT]: [],
  [PipelineStepType.CONVERT_TO_ASM]: ['Connect'],
  [PipelineStepType.CREATE_DATASET_FROM_FILE]: ['Connect'],
  [PipelineStepType.CREATE_METERING_USAGE_CHART]: [],
  [PipelineStepType.CREATE_PROCEDURE_DATASET]: ['Create table'],
  [PipelineStepType.DATA_CATALOG_DATASET]: ['Create table'],
  [PipelineStepType.DATA_CATALOG_FILE]: ['Create file'],
  [PipelineStepType.DATA_CATALOG_FILES]: ['Create file'],
  [PipelineStepType.DATASET_VIEW]: ['Views'],
  [PipelineStepType.DEFINE_TEMPLATE_VARIABLES]: ['Analysis templates'],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_BOOTSTRAP]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_CLEAN_DATA]: ['Experiment optimization'],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_EXPLANATION]: ['Experiment optimization'],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE]: ['Experiment optimization'],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_RECOMMENDATION]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_TRAINING]: ['Experiment optimization'],
  [PipelineStepType.EXPLORATORY_DATA_ANALYSIS]: ['Experiment optimization'],
  [PipelineStepType.EXPORT_DATA_CATALOG_DATASET]: ['Outputs'],
  [PipelineStepType.EXPORT_DATA_CATALOG_FILE]: ['Outputs'],
  [PipelineStepType.EXTRACT_DATA_FRAME_VALUE]: [],
  [PipelineStepType.EXTRACT_OR_REMOVE_LINES]: ['Connect'],
  [PipelineStepType.FILTER_DATASET]: ['Transform'],
  [PipelineStepType.FIND_AND_REPLACE]: ['Transform'],
  [PipelineStepType.FLAG_ROWS]: [],
  [PipelineStepType.GENERATE_BOLTZ_YAML]: [],
  [PipelineStepType.GENERATE_BOLTZGEN_YAML]: [],
  [PipelineStepType.GENERATE_FASTA]: [],
  [PipelineStepType.GENERATE_OPENFOLD2_JSON]: [],
  [PipelineStepType.HIDE_COLUMNS]: ['Transform'],
  [PipelineStepType.IMPORT_SCRATCH_FILE]: ['Create file'],
  [PipelineStepType.INITIALIZE_DATASET]: ['Create table'],
  [PipelineStepType.INTERPOLATE_MARKDOWN]: ['Create file'],
  [PipelineStepType.JOIN]: ['Combine tables'],
  [PipelineStepType.LAYOUT]: [],
  [PipelineStepType.LOOK_UP]: ['Create table'],
  [PipelineStepType.MAP_COLUMNS]: ['Transform'],
  [PipelineStepType.MAP_JSON_TO_DATASETS_AND_FILES]: ['Connect'],
  [PipelineStepType.NOTEBOOK_TABLE_DATASET]: ['Create table'],
  [PipelineStepType.OPENFOLD2]: [],
  [PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION]: ['Experiment optimization'],
  [PipelineStepType.PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION]: ['Experiment optimization'],
  [PipelineStepType.PARAMETER_OPTIMIZATION_MODELING]: ['Experiment optimization'],
  [PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION]: ['Experiment optimization'],
  [PipelineStepType.PIVOT_DATASET]: ['Transform'],
  [PipelineStepType.PLATE_SCHEMA_DATASET]: ['Create table'],
  [PipelineStepType.PROCEDURE_RUN_DATA_FRAMES]: [],
  [PipelineStepType.PROMOTE_DATASET]: ['Views'],
  [PipelineStepType.REGISTRY_SCHEMA_DATASET]: ['Create table'],
  [PipelineStepType.REGRESSION]: ['Statistics'],
  [PipelineStepType.REGRESSION_INTERPOLATION]: ['Statistics'],
  [PipelineStepType.RENAME_COLUMNS]: ['Transform'],
  [PipelineStepType.REORDER_COLUMNS]: ['Transform'],
  [PipelineStepType.RETYPE_COLUMNS]: ['Transform'],
  [PipelineStepType.RUN_HIGHRES_PROTOCOL]: ['Connect'],
  [PipelineStepType.SAVE_STRUCTURE_PREDICTION]: [],
  [PipelineStepType.SAVE_TO_RESULTS]: ['Outputs'],
  [PipelineStepType.SEND_TO_CONNECTION]: ['Connect'],
  [PipelineStepType.SEND_TO_DOCUMENT]: ['Outputs'],
  [PipelineStepType.SORT_COLUMNS]: ['Transform'],
  [PipelineStepType.T_TEST]: ['Statistics'],
  [PipelineStepType.TABLE_VIEW]: ['Views'],
  [PipelineStepType.TEMPLATE_INPUT]: ['Create table'],
  [PipelineStepType.TEST_ALL_CONFIGS]: [],
  [PipelineStepType.THIRD_PARTY]: [],
  [PipelineStepType.UNION_DATASETS]: ['Combine tables'],
  [PipelineStepType.UNPIVOT_DATASET]: ['Transform'],
  [PipelineStepType.UPLOAD_CSV_DATASET]: ['Create table'],
  [PipelineStepType.USER_DEFINED_FUNCTION]: ['Code'],
  [PipelineStepType.WINDOW_FUNCTIONS]: ['Transform'],
};
export const STEP_TYPE_TO_DESCRIPTION: Record<PipelineStepType, string | null> = {
  [PipelineStepType.AGGREGATE_DATASET]: 'Calculates a summary of your data.',
  [PipelineStepType.ANOVA]: 'Compares means across three or more groups to determine if differences are statistically significant.',
  [PipelineStepType.BIN_DATA]: 'Groups continuous values into bins.',
  [PipelineStepType.BOLTZ2]: 'Predicts protein structures using the Boltz-2 AI model for biomolecular modeling.',
  [PipelineStepType.BOLTZGEN]: 'Runs BoltzGen to generate molecular structures.',
  [PipelineStepType.BOLTZGEN_SUCCESS]: 'Validates successful completion of BoltzGen structure generation.',
  [PipelineStepType.CHAI1]: 'Predicts protein structures using the Chai-1 AI model.',
  [PipelineStepType.CHART_VIEW]: 'Visualizes your data in an interactive chart.',
  [PipelineStepType.COMPUTED_COLUMN]: 'Creates a new column based off a given formula.',
  [PipelineStepType.CONNECTION_DATA_DATASET]: 'Imports data from an external connection into your analysis.',
  [PipelineStepType.CONVERT_ASM_TO_CSV]: 'Converts ASM format data to CSV for easier analysis and manipulation.',
  [PipelineStepType.CONVERT_FILE_TO_DATASET_WITH_DATA_ENTRY_ASSISTANT]: 'AI data entry assistant.',
  [PipelineStepType.CONVERT_JSON_TO_DATASET]: null,
  [PipelineStepType.CONVERT_OPENFOLD2_OUTPUT]: null,
  [PipelineStepType.CONVERT_TO_ASM]: null,
  [PipelineStepType.CREATE_DATASET_FROM_FILE]: null,
  [PipelineStepType.CREATE_METERING_USAGE_CHART]: null,
  [PipelineStepType.CREATE_PROCEDURE_DATASET]: null,
  [PipelineStepType.DATA_CATALOG_DATASET]: 'Loads an existing dataset from your data catalog.',
  [PipelineStepType.DATA_CATALOG_FILE]: 'Loads an existing file from your data catalog into your analysis.',
  [PipelineStepType.DATA_CATALOG_FILES]: 'Loads existing files from your data catalog into your analysis.',
  [PipelineStepType.DATASET_VIEW]: null,
  [PipelineStepType.DEFINE_TEMPLATE_VARIABLES]: 'Add additional input values to your analysis template',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_BOOTSTRAP]: null,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_CLEAN_DATA]: 'Prepares and validates your data for use in experiment optimization workflows.',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_EXPLANATION]: 'Provides insights and explanations about the experiment optimization recommendations.',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE]: 'Defines the range of possible parameter values to explore during experiment optimization.',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY]: 'Summarizes the statistical distribution of optimized parameters.',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_RECOMMENDATION]: 'Suggests optimal parameter values to improve your experimental outcomes.',
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_TRAINING]: 'Trains a statistical model to guide experiment optimization.',
  [PipelineStepType.EXPLORATORY_DATA_ANALYSIS]: 'Generates visualizations and summary statistics to explore patterns in your data.',
  [PipelineStepType.EXPORT_DATA_CATALOG_DATASET]: null,
  [PipelineStepType.EXPORT_DATA_CATALOG_FILE]: null,
  [PipelineStepType.EXTRACT_DATA_FRAME_VALUE]: null,
  [PipelineStepType.EXTRACT_OR_REMOVE_LINES]: 'Keeps or removes specific lines from text files based on patterns or line numbers.',
  [PipelineStepType.FILTER_DATASET]: 'Keeps only the rows that meet your specified conditions.',
  [PipelineStepType.FIND_AND_REPLACE]: 'Searches for specific text patterns and replaces them with new values.',
  [PipelineStepType.FLAG_ROWS]: 'Marks specific rows with flags and optional comments to highlight important or problematic data points.',
  [PipelineStepType.GENERATE_BOLTZ_YAML]: 'Generates configuration files for running Boltz structure predictions.',
  [PipelineStepType.GENERATE_BOLTZGEN_YAML]: 'Generates configuration files for running BoltzGen structure generation.',
  [PipelineStepType.GENERATE_FASTA]: 'Creates FASTA format file from AA sequence entity for use in structure prediction runs.',
  [PipelineStepType.GENERATE_OPENFOLD2_JSON]: null,
  [PipelineStepType.HIDE_COLUMNS]: 'Removes columns from the input data.',
  [PipelineStepType.IMPORT_SCRATCH_FILE]: null,
  [PipelineStepType.INITIALIZE_DATASET]: 'Creates a table by pulling data from an Insights dashboard block query.',
  [PipelineStepType.INTERPOLATE_MARKDOWN]: 'Creates a markdown file, which can incorporate values from the input data.',
  [PipelineStepType.JOIN]: 'Combines two tables based on matching values in specified columns to create a single unified dataset.',
  [PipelineStepType.LAYOUT]: 'Visually organizes data and provides ways to interact with it.',
  [PipelineStepType.LOOK_UP]: 'Enriches your data by looking up additional information from Benchling entities based on identifiers in your table.',
  [PipelineStepType.MAP_COLUMNS]: 'Renames the columns in its input datasets.',
  [PipelineStepType.MAP_JSON_TO_DATASETS_AND_FILES]: null,
  [PipelineStepType.NOTEBOOK_TABLE_DATASET]: null,
  [PipelineStepType.OPENFOLD2]: null,
  [PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION]: 'Adjusts parameters automatically to find the best settings that improve model performance or analysis results.',
  [PipelineStepType.PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION]: 'Adjusts parameters automatically to find the best settings that improve model performance or analysis results.',
  [PipelineStepType.PARAMETER_OPTIMIZATION_MODELING]: 'Adjusts parameters automatically to find the best settings that improve model performance or analysis results.',
  [PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION]: 'Adjusts parameters automatically to find the best settings that improve model performance or analysis results.',
  [PipelineStepType.PIVOT_DATASET]: 'Reorganizes your data by turning row values into column headers to view summaries across different categories.',
  [PipelineStepType.PLATE_SCHEMA_DATASET]: 'Loads plate layout and metadata from a plate schema.',
  [PipelineStepType.PROCEDURE_RUN_DATA_FRAMES]: null,
  [PipelineStepType.PROMOTE_DATASET]: 'Converts input data into a top-level table.',
  [PipelineStepType.REGISTRY_SCHEMA_DATASET]: 'Loads data from a registry entity schema into your analysis.',
  [PipelineStepType.REGRESSION]: null,
  [PipelineStepType.REGRESSION_INTERPOLATION]: 'Uses regression results to predict new values for the input data.',
  [PipelineStepType.RENAME_COLUMNS]: 'Changes the names of one or more columns.',
  [PipelineStepType.REORDER_COLUMNS]: 'Rearranges the order of columns.',
  [PipelineStepType.RETYPE_COLUMNS]: 'Changes the format for data in the column across a variety of types i.e. integer, text, entity, etc.',
  [PipelineStepType.RUN_HIGHRES_PROTOCOL]: 'Executes a high-resolution protocol workflow.',
  [PipelineStepType.SAVE_STRUCTURE_PREDICTION]: 'Saves predicted protein structures to your Benchling inventory.',
  [PipelineStepType.SAVE_TO_RESULTS]: 'Saves selected data as results that can be added to notebooks and other documents.',
  [PipelineStepType.SEND_TO_CONNECTION]: 'Sends data to an external system through a configured connection.',
  [PipelineStepType.SEND_TO_DOCUMENT]: 'Adds tables, charts, and results directly into a notebook entry or document.',
  [PipelineStepType.SORT_COLUMNS]: 'Arranges rows in ascending or descending order based on values in one or more columns.',
  [PipelineStepType.T_TEST]: 'Compares means between two groups to determine if the difference is statistically significant.',
  [PipelineStepType.TABLE_VIEW]: 'Displays your data in a tabular format for easy viewing and analysis.',
  [PipelineStepType.TEMPLATE_INPUT]: null,
  [PipelineStepType.TEST_ALL_CONFIGS]: null,
  [PipelineStepType.THIRD_PARTY]: 'Integrates external tools and services into your analysis workflow.',
  [PipelineStepType.UNION_DATASETS]: 'Stacks multiple tables vertically by combining rows from all tables into a single dataset.',
  [PipelineStepType.UNPIVOT_DATASET]: 'Converts column headers into row values to restructure your data into a longer format for easier analysis.',
  [PipelineStepType.UPLOAD_CSV_DATASET]: null,
  [PipelineStepType.USER_DEFINED_FUNCTION]: 'Write your own code to process and transform data or further enhance the automation.',
  [PipelineStepType.WINDOW_FUNCTIONS]: 'Calculates values based on groups of related rows using running totals, ranks, or other rolling calculations.',
};
export const STEP_TYPE_TO_REQUIRED_CAPABILITIES: Record<PipelineStepType, Array<string>> = {
  [PipelineStepType.AGGREGATE_DATASET]: [],
  [PipelineStepType.ANOVA]: ['ADVANCED_ANALYSIS_CREATE_STATISTICS'],
  [PipelineStepType.BIN_DATA]: [],
  [PipelineStepType.BOLTZ2]: [],
  [PipelineStepType.BOLTZGEN]: [],
  [PipelineStepType.BOLTZGEN_SUCCESS]: [],
  [PipelineStepType.CHAI1]: [],
  [PipelineStepType.CHART_VIEW]: [],
  [PipelineStepType.COMPUTED_COLUMN]: [],
  [PipelineStepType.CONNECTION_DATA_DATASET]: ['CONNECT'],
  [PipelineStepType.CONVERT_ASM_TO_CSV]: ['CONNECT'],
  [PipelineStepType.CONVERT_FILE_TO_DATASET_WITH_DATA_ENTRY_ASSISTANT]: ['AI_DATA_ENTRY'],
  [PipelineStepType.CONVERT_JSON_TO_DATASET]: ['CONNECT'],
  [PipelineStepType.CONVERT_OPENFOLD2_OUTPUT]: [],
  [PipelineStepType.CONVERT_TO_ASM]: ['CONNECT'],
  [PipelineStepType.CREATE_DATASET_FROM_FILE]: ['CONNECT'],
  [PipelineStepType.CREATE_METERING_USAGE_CHART]: [],
  [PipelineStepType.CREATE_PROCEDURE_DATASET]: ['CREATE_PROCEDURE_DATASET'],
  [PipelineStepType.DATA_CATALOG_DATASET]: [],
  [PipelineStepType.DATA_CATALOG_FILE]: ['CONNECT'],
  [PipelineStepType.DATA_CATALOG_FILES]: ['CONNECT'],
  [PipelineStepType.DATASET_VIEW]: [],
  [PipelineStepType.DEFINE_TEMPLATE_VARIABLES]: ['ADVANCED_ANALYSIS_CREATE_TEMPLATES'],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_BOOTSTRAP]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_CLEAN_DATA]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_EXPLANATION]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_RECOMMENDATION]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_TRAINING]: [],
  [PipelineStepType.EXPLORATORY_DATA_ANALYSIS]: [],
  [PipelineStepType.EXPORT_DATA_CATALOG_DATASET]: [],
  [PipelineStepType.EXPORT_DATA_CATALOG_FILE]: ['CONNECT'],
  [PipelineStepType.EXTRACT_DATA_FRAME_VALUE]: [],
  [PipelineStepType.EXTRACT_OR_REMOVE_LINES]: ['CONNECT'],
  [PipelineStepType.FILTER_DATASET]: [],
  [PipelineStepType.FIND_AND_REPLACE]: [],
  [PipelineStepType.FLAG_ROWS]: [],
  [PipelineStepType.GENERATE_BOLTZ_YAML]: [],
  [PipelineStepType.GENERATE_BOLTZGEN_YAML]: [],
  [PipelineStepType.GENERATE_FASTA]: [],
  [PipelineStepType.GENERATE_OPENFOLD2_JSON]: [],
  [PipelineStepType.HIDE_COLUMNS]: [],
  [PipelineStepType.IMPORT_SCRATCH_FILE]: [],
  [PipelineStepType.INITIALIZE_DATASET]: [],
  [PipelineStepType.INTERPOLATE_MARKDOWN]: [],
  [PipelineStepType.JOIN]: [],
  [PipelineStepType.LAYOUT]: [],
  [PipelineStepType.LOOK_UP]: [],
  [PipelineStepType.MAP_COLUMNS]: [],
  [PipelineStepType.MAP_JSON_TO_DATASETS_AND_FILES]: ['CONNECT'],
  [PipelineStepType.NOTEBOOK_TABLE_DATASET]: [],
  [PipelineStepType.OPENFOLD2]: [],
  [PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION]: [],
  [PipelineStepType.PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION]: [],
  [PipelineStepType.PARAMETER_OPTIMIZATION_MODELING]: [],
  [PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION]: [],
  [PipelineStepType.PIVOT_DATASET]: [],
  [PipelineStepType.PLATE_SCHEMA_DATASET]: [],
  [PipelineStepType.PROCEDURE_RUN_DATA_FRAMES]: [],
  [PipelineStepType.PROMOTE_DATASET]: [],
  [PipelineStepType.REGISTRY_SCHEMA_DATASET]: [],
  [PipelineStepType.REGRESSION]: ['ADVANCED_ANALYSIS_CREATE_STATISTICS'],
  [PipelineStepType.REGRESSION_INTERPOLATION]: ['ADVANCED_ANALYSIS_CREATE_STATISTICS'],
  [PipelineStepType.RENAME_COLUMNS]: [],
  [PipelineStepType.REORDER_COLUMNS]: [],
  [PipelineStepType.RETYPE_COLUMNS]: [],
  [PipelineStepType.RUN_HIGHRES_PROTOCOL]: ['CONNECT'],
  [PipelineStepType.SAVE_STRUCTURE_PREDICTION]: [],
  [PipelineStepType.SAVE_TO_RESULTS]: [],
  [PipelineStepType.SEND_TO_CONNECTION]: ['CONNECT'],
  [PipelineStepType.SEND_TO_DOCUMENT]: [],
  [PipelineStepType.SORT_COLUMNS]: [],
  [PipelineStepType.T_TEST]: ['ADVANCED_ANALYSIS_CREATE_STATISTICS'],
  [PipelineStepType.TABLE_VIEW]: [],
  [PipelineStepType.TEMPLATE_INPUT]: [],
  [PipelineStepType.TEST_ALL_CONFIGS]: ['ENGINEERING_ONLY'],
  [PipelineStepType.THIRD_PARTY]: [],
  [PipelineStepType.UNION_DATASETS]: [],
  [PipelineStepType.UNPIVOT_DATASET]: [],
  [PipelineStepType.UPLOAD_CSV_DATASET]: [],
  [PipelineStepType.USER_DEFINED_FUNCTION]: ['CUSTOM_CODE'],
  [PipelineStepType.WINDOW_FUNCTIONS]: [],
};
export const STEP_TYPE_TO_TAGS: Record<PipelineStepType, Array<string>> = {
  [PipelineStepType.AGGREGATE_DATASET]: [],
  [PipelineStepType.ANOVA]: [],
  [PipelineStepType.BIN_DATA]: [],
  [PipelineStepType.BOLTZ2]: [],
  [PipelineStepType.BOLTZGEN]: [],
  [PipelineStepType.BOLTZGEN_SUCCESS]: [],
  [PipelineStepType.CHAI1]: [],
  [PipelineStepType.CHART_VIEW]: [],
  [PipelineStepType.COMPUTED_COLUMN]: [],
  [PipelineStepType.CONNECTION_DATA_DATASET]: [],
  [PipelineStepType.CONVERT_ASM_TO_CSV]: ['beta'],
  [PipelineStepType.CONVERT_FILE_TO_DATASET_WITH_DATA_ENTRY_ASSISTANT]: ['beta'],
  [PipelineStepType.CONVERT_JSON_TO_DATASET]: ['beta'],
  [PipelineStepType.CONVERT_OPENFOLD2_OUTPUT]: [],
  [PipelineStepType.CONVERT_TO_ASM]: ['beta'],
  [PipelineStepType.CREATE_DATASET_FROM_FILE]: ['beta'],
  [PipelineStepType.CREATE_METERING_USAGE_CHART]: [],
  [PipelineStepType.CREATE_PROCEDURE_DATASET]: [],
  [PipelineStepType.DATA_CATALOG_DATASET]: [],
  [PipelineStepType.DATA_CATALOG_FILE]: [],
  [PipelineStepType.DATA_CATALOG_FILES]: ['beta'],
  [PipelineStepType.DATASET_VIEW]: [],
  [PipelineStepType.DEFINE_TEMPLATE_VARIABLES]: ['beta'],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_BOOTSTRAP]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_CLEAN_DATA]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_EXPLANATION]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_RECOMMENDATION]: [],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_TRAINING]: [],
  [PipelineStepType.EXPLORATORY_DATA_ANALYSIS]: [],
  [PipelineStepType.EXPORT_DATA_CATALOG_DATASET]: [],
  [PipelineStepType.EXPORT_DATA_CATALOG_FILE]: [],
  [PipelineStepType.EXTRACT_DATA_FRAME_VALUE]: [],
  [PipelineStepType.EXTRACT_OR_REMOVE_LINES]: ['beta'],
  [PipelineStepType.FILTER_DATASET]: [],
  [PipelineStepType.FIND_AND_REPLACE]: [],
  [PipelineStepType.FLAG_ROWS]: [],
  [PipelineStepType.GENERATE_BOLTZ_YAML]: [],
  [PipelineStepType.GENERATE_BOLTZGEN_YAML]: [],
  [PipelineStepType.GENERATE_FASTA]: [],
  [PipelineStepType.GENERATE_OPENFOLD2_JSON]: [],
  [PipelineStepType.HIDE_COLUMNS]: [],
  [PipelineStepType.IMPORT_SCRATCH_FILE]: [],
  [PipelineStepType.INITIALIZE_DATASET]: [],
  [PipelineStepType.INTERPOLATE_MARKDOWN]: [],
  [PipelineStepType.JOIN]: [],
  [PipelineStepType.LAYOUT]: [],
  [PipelineStepType.LOOK_UP]: ['beta'],
  [PipelineStepType.MAP_COLUMNS]: [],
  [PipelineStepType.MAP_JSON_TO_DATASETS_AND_FILES]: ['beta'],
  [PipelineStepType.NOTEBOOK_TABLE_DATASET]: [],
  [PipelineStepType.OPENFOLD2]: [],
  [PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION]: [],
  [PipelineStepType.PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION]: [],
  [PipelineStepType.PARAMETER_OPTIMIZATION_MODELING]: [],
  [PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION]: [],
  [PipelineStepType.PIVOT_DATASET]: [],
  [PipelineStepType.PLATE_SCHEMA_DATASET]: [],
  [PipelineStepType.PROCEDURE_RUN_DATA_FRAMES]: [],
  [PipelineStepType.PROMOTE_DATASET]: [],
  [PipelineStepType.REGISTRY_SCHEMA_DATASET]: [],
  [PipelineStepType.REGRESSION]: [],
  [PipelineStepType.REGRESSION_INTERPOLATION]: [],
  [PipelineStepType.RENAME_COLUMNS]: [],
  [PipelineStepType.REORDER_COLUMNS]: [],
  [PipelineStepType.RETYPE_COLUMNS]: [],
  [PipelineStepType.RUN_HIGHRES_PROTOCOL]: ['beta'],
  [PipelineStepType.SAVE_STRUCTURE_PREDICTION]: [],
  [PipelineStepType.SAVE_TO_RESULTS]: [],
  [PipelineStepType.SEND_TO_CONNECTION]: ['beta'],
  [PipelineStepType.SEND_TO_DOCUMENT]: [],
  [PipelineStepType.SORT_COLUMNS]: [],
  [PipelineStepType.T_TEST]: [],
  [PipelineStepType.TABLE_VIEW]: [],
  [PipelineStepType.TEMPLATE_INPUT]: [],
  [PipelineStepType.TEST_ALL_CONFIGS]: [],
  [PipelineStepType.THIRD_PARTY]: [],
  [PipelineStepType.UNION_DATASETS]: [],
  [PipelineStepType.UNPIVOT_DATASET]: [],
  [PipelineStepType.UPLOAD_CSV_DATASET]: [],
  [PipelineStepType.USER_DEFINED_FUNCTION]: ['beta'],
  [PipelineStepType.WINDOW_FUNCTIONS]: [],
};
export const ACTION_ORIGIN: Record<ActionOrigin, string> = {
  [ActionOrigin.ANALYSIS_TOOL]: 'analysis_tool',
  [ActionOrigin.ANALYSIS_TOOL_ANALYSIS_PAGE_DATA_FRAME_SIDEPANEL]: 'analysis_tool_analysis_page_data_frame_sidepanel',
  [ActionOrigin.ANALYSIS_TOOL_CHOOSE_DATA_FRAME_CREATION_VIEW]: 'analysis_tool_choose_data_frame_creation_view',
  [ActionOrigin.ANALYSIS_TOOL_DATA_MAPPER_TOOL]: 'analysis_tool_data_mapper_tool',
  [ActionOrigin.ANALYSIS_TOOL_EMPTY_ANALYSIS_PAGE]: 'analysis_tool_empty_analysis_page',
  [ActionOrigin.ANALYSIS_TOOL_SAVE_TO_RESULTS_CONFIGURATION_VIEW]: 'analysis_tool_save_to_results_configuration_view',
  [ActionOrigin.API]: 'api',
  [ActionOrigin.API_V3_REST]: 'api_v3_rest',
  [ActionOrigin.ANTIBODY_NESTED_DATA_CREATION]: 'antibody_nested_data_creation',
  [ActionOrigin.CHEMISTRY_ITEM_PAGE_CHEMICAL_STRUCTURE_TAB]: 'chemistry_item_page_chemical_structure_tab',
  [ActionOrigin.COLLABORATION_MANAGEMENT_MODAL]: 'collaboration_management_modal',
  [ActionOrigin.CONFIG_MIGRATION]: 'config_migration',
  [ActionOrigin.CONFIG_MIGRATION_EXPORT_TAB]: 'config_migration_export_tab',
  [ActionOrigin.CONFIG_MIGRATION_IMPORT_TAB]: 'config_migration_import_tab',
  [ActionOrigin.CONFIG_MIGRATION_MANAGEMENT_HISTORY_TABLE]: 'config_migration_history_table',
  [ActionOrigin.CONNECTION_PAGE]: 'connection_page',
  [ActionOrigin.CONNECTIONS_SIDEPANEL]: 'connections_sidepanel',
  [ActionOrigin.CREATE_CONNECTIONS_MODAL]: 'create_connections_modal',
  [ActionOrigin.DATASET_PAGE]: 'dataset_page',
  [ActionOrigin.DOCUMENT]: 'document',
  [ActionOrigin.ENTITY_PAGE_METADATA_TAB_SCHEMA_TABLE]: 'entity_page_metadata_tab_schema_table',
  [ActionOrigin.FORMS_CREATE_FORM_DEFINITION_DESIGNER]: 'forms_create_form_definition_designer',
  [ActionOrigin.FORMS_EDIT_FORM_DEFINITION_DESIGNER]: 'forms_edit_form_definition_designer',
  [ActionOrigin.INSIGHTS_EXPANDED_SEARCH_TOOLBAR]: 'insights_expanded_search_toolbar',
  [ActionOrigin.INSIGHTS]: 'insights',
  [ActionOrigin.INSIGHTS_SIDEPANEL]: 'insights_sidepanel',
  [ActionOrigin.INTERNAL_ADMIN_PAGE]: 'internal_admin_page',
  [ActionOrigin.INTERNAL_ADMIN_TOOLS_UPDATE_POLICIES_PAGE]: 'internal_admin_tools_update_policies_page',
  [ActionOrigin.INTERNAL_CONVERSION_TOOL]: 'internal_conversion_tool',
  [ActionOrigin.INVENTORY_BOX_PAGE]: 'inventory_box_page',
  [ActionOrigin.INVENTORY_BOX_PAGE_GRID_CELL_TABLE]: 'inventory_box_page_grid_cell_table',
  [ActionOrigin.INVENTORY_BOX_PAGE_GRID_CELL_TOOLBAR]: 'inventory_box_page_grid_cell_toolbar',
  [ActionOrigin.INVENTORY_BOX_PAGE_TOOLBAR]: 'inventory_box_page_toolbar',
  [ActionOrigin.INVENTORY_CONTAINER_PAGE]: 'inventory_container_page',
  [ActionOrigin.INVENTORY_CONTAINER_PAGE_TOOLBAR]: 'inventory_container_page_toolbar',
  [ActionOrigin.INVENTORY_EXPANDED_SEARCH_TABLE]: 'inventory_expanded_search_table',
  [ActionOrigin.INVENTORY_EXPANDED_SEARCH_TOOLBAR]: 'inventory_expanded_search_toolbar',
  [ActionOrigin.INVENTORY_LOCATION_PAGE]: 'inventory_location_page',
  [ActionOrigin.INVENTORY_PLATE_PAGE]: 'inventory_plate_page',
  [ActionOrigin.INVENTORY_PLATE_PAGE_GRID_CELL_TABLE]: 'inventory_plate_page_grid_cell_table',
  [ActionOrigin.INVENTORY_PLATE_PAGE_GRID_CELL_TOOLBAR]: 'inventory_plate_page_grid_cell_toolbar',
  [ActionOrigin.INVENTORY_PLATE_PAGE_TOOLBAR]: 'inventory_plate_page_toolbar',
  [ActionOrigin.INVENTORY_REGISTRY_SEARCH_UI]: 'inventory_registry_search_ui',
  [ActionOrigin.INVENTORY_SIDEPANEL_CREATE]: 'inventory_sidepanel_create',
  [ActionOrigin.INVENTORY_SIDEPANEL_HEADER]: 'inventory_sidepanel_header',
  [ActionOrigin.INVENTORY_SIDEPANEL_ITEM]: 'inventory_sidepanel_item',
  [ActionOrigin.ITEM_DISPLAY_TABLE]: 'item_display_table',
  [ActionOrigin.JELLYFISH_SIDEPANEL]: 'jellyfish_sidepanel',
  [ActionOrigin.LIBRARY_SIDEPANEL]: 'library_sidepanel',
  [ActionOrigin.MACHINE_LEARNING]: 'machine_learning',
  [ActionOrigin.MODBIO_COMPLEX_POLYMERS]: 'modbio_complex_polymers',
  [ActionOrigin.MODBIO_MOD_PATTERNS]: 'modbio_mod_patterns',
  [ActionOrigin.MODBIO_MONOMER_LIBRARY_PAGE]: 'modbio_monomer_library_page',
  [ActionOrigin.MODBIO_NUCLEOTIDES_TAB]: 'modbio_nucleotides_tab',
  [ActionOrigin.MOLBIO]: 'molbio',
  [ActionOrigin.MOLBIO_BULK_ASSEMBLY]: 'molbio_bulk_assembly',
  [ActionOrigin.MOLBIO_ASSEMBLY_WIZARD_MODAL]: 'molbio_assembly_wizard_modal',
  [ActionOrigin.MOLBIO_BIOINTELLIGENT_LINK_COMPONENT_REPLACE]: 'molbio_biointelligent_link_component_replace',
  [ActionOrigin.MOLBIO_BULK_ASSEMBLY_BETA_BANNER]: 'molbio_bulk_assembly_beta_banner',
  [ActionOrigin.MOLBIO_BULK_ASSEMBLY_SETTINGS_MODAL]: 'molbio_bulk_assembly_settings_modal',
  [ActionOrigin.MOLBIO_BULK_ASSEMBLY_OVERVIEW_TAB]: 'molbio_bulk_assembly_overview_tab',
  [ActionOrigin.MOLBIO_BULK_ASSEMBLY_FRAGMENT_MODAL]: 'molbio_bulk_assembly_fragment_modal',
  [ActionOrigin.MOLBIO_BULK_ASSEMBLY_FRAGMENTS_TABLE]: 'molbio_bulk_assembly_fragments_table',
  [ActionOrigin.MOLBIO_BULK_ASSEMBLY_CONSTRUCTS_TABLE]: 'molbio_bulk_assembly_constructs_table',
  [ActionOrigin.MOLBIO_BULK_ASSEMBLY_CONSTRUCT_MODAL]: 'molbio_bulk_assembly_construct_modal',
  [ActionOrigin.MOLBIO_BULK_ASSEMBLY_FINALIZATION_MODAL]: 'molbio_bulk_assembly_finalization_modal',
  [ActionOrigin.MOLBIO_BULK_ASSEMBLY_BIN_LAYOUT]: 'molbio_bulk_assembly_bin_layout',
  [ActionOrigin.MODEL_HUB_STRUCTURE_PREDICTION_COMPONENT_SEARCH]: 'model_hub_structure_prediction_component_search',
  [ActionOrigin.MODEL_HUB_STRUCTURE_PREDICTION_FORM_PAGE]: 'model_hub_structure_prediction_form_page',
  [ActionOrigin.MODEL_HUB_STRUCTURE_PREDICTION_PREDICTION_LIST_PAGE]: 'model_hub_structure_prediction_prediction_list_page',
  [ActionOrigin.NOTEBOOK]: 'notebook',
  [ActionOrigin.NOTEBOOK_ENTRY_BOX_CREATION_TABLE]: 'notebook_entry_box_creation_table',
  [ActionOrigin.NOTEBOOK_ENTRY_CONTAINER_CREATION_TABLE]: 'notebook_entry_container_creation_table',
  [ActionOrigin.NOTEBOOK_ENTRY_FILL_EXISTING_TABLE]: 'notebook_entry_fill_existing_table',
  [ActionOrigin.NOTEBOOK_ENTRY_INVENTORY_UPDATE_TABLE]: 'notebook_entry_inventory_update_table',
  [ActionOrigin.NOTEBOOK_ENTRY_LEGACY_REGISTRATION_TABLE]: 'notebook_entry_legacy_registration_table',
  [ActionOrigin.NOTEBOOK_ENTRY_LEGACY_RESULTS_TABLE]: 'notebook_entry_legacy_results_table',
  [ActionOrigin.NOTEBOOK_ENTRY_LEGACY_RUN]: 'notebook_entry_legacy_run',
  [ActionOrigin.NOTEBOOK_ENTRY_LEGACY_STAGE_ENTRY_TRANSFER_TABLE]: 'notebook_entry_legacy_stage_entry_transfer_table',
  [ActionOrigin.NOTEBOOK_ENTRY_LEGACY_TRANSFER_TABLE]: 'notebook_entry_legacy_transfer_table',
  [ActionOrigin.NOTEBOOK_ENTRY_LOOKUP_TABLE]: 'notebook_entry_lookup_table',
  [ActionOrigin.NOTEBOOK_ENTRY_MIXTURE_PREP_TABLE]: 'notebook_entry_mixture_prep_table',
  [ActionOrigin.NOTEBOOK_ENTRY_PLATE_CREATION_TABLE]: 'notebook_entry_plate_creation_table',
  [ActionOrigin.NOTEBOOK_ENTRY_REGISTRATION_TABLE]: 'notebook_entry_registration_table',
  [ActionOrigin.NOTEBOOK_ENTRY_RESULTS_TABLE]: 'notebook_entry_results_table',
  [ActionOrigin.NOTEBOOK_ENTRY_RUN]: 'notebook_entry_run',
  [ActionOrigin.NOTEBOOK_ENTRY_RUN_OUTPUT_SAMPLES_TABLE]: 'notebook_entry_run_output_samples_table',
  [ActionOrigin.NOTEBOOK_ENTRY_WORKFLOW_OUTPUT_TABLE]: 'notebook_entry_workflow_output_table',
  [ActionOrigin.NOTEBOOK_ENTRY_WORKFLOW_TASK_TABLE]: 'notebook_entry_workflow_task_table',
  [ActionOrigin.NOTEBOOK_PLAIN_TABLE]: 'notebook_plain_table',
  [ActionOrigin.NOTEBOOK_TEMPLATE_COLLECTION_PAGE]: 'notebook_template_collection_page',
  [ActionOrigin.NOTEBOOK_UNDETERMINED_STRUCTURED_TABLE]: 'notebook_undetermined_structured_table',
  [ActionOrigin.PARAMETER_LIBRARY]: 'parameter_library',
  [ActionOrigin.PROCEDURE_DESIGNER]: 'procedure_designer',
  [ActionOrigin.PROCEDURE_DESIGNER_FLOWCHART]: 'procedure_designer_flowchart',
  [ActionOrigin.PROCEDURE_DESIGNER_DETAILS]: 'procedure_designer_details',
  [ActionOrigin.PROCEDURE_EXPERIMENT_DESIGNER]: 'procedure_experiment_designer',
  [ActionOrigin.PROJECTS_SIDEPANEL]: 'projects_sidepanel',
  [ActionOrigin.REGISTRY_EXPANDED_SEARCH]: 'registry_expanded_search',
  [ActionOrigin.REGISTRY_EXPANDED_SEARCH_TOOLBAR]: 'registry_expanded_search_toolbar',
  [ActionOrigin.REGISTRY_ITEM_PAGE]: 'registry_item_page',
  [ActionOrigin.REGISTRY_ITEM_PAGE_CHILD_ENTITY_TAB]: 'registry_item_page_child_entity_tab',
  [ActionOrigin.REGISTRY_ITEM_PAGE_DESCRIPTION_TAB]: 'registry_item_page_description_tab',
  [ActionOrigin.REGISTRY_ITEM_PAGE_HISTORY_PANEL]: 'registry_item_page_history_panel',
  [ActionOrigin.REGISTRY_ITEM_PAGE_STORAGE_TAB]: 'registry_item_page_storage_tab',
  [ActionOrigin.REGISTRY_ITEM_PAGE_TOOLBAR]: 'registry_item_page_toolbar',
  [ActionOrigin.REGISTRY_SIDEPANEL_CREATE]: 'registry_sidepanel_create',
  [ActionOrigin.REQUEST_V2_DEFINITION_CONFIG_PAGE]: 'request_v2_definition_config_page',
  [ActionOrigin.REQUEST_V2_SIDEPANEL]: 'request_v2_sidepanel',
  [ActionOrigin.REQUEST_V2_SUBMISSION]: 'request_v2_submission',
  [ActionOrigin.RUN_PAGE]: 'run_page',
  [ActionOrigin.RUN_PAGE_TOOLBAR]: 'run_page_toolbar',
  [ActionOrigin.SEARCH_EXPANDED_SEARCH_TABLE]: 'search_expanded_search_table',
  [ActionOrigin.SEARCH_EXPANDED_SEARCH_TOOLBAR]: 'search_expanded_search_toolbar',
  [ActionOrigin.SEARCH_SIDEPANEL]: 'search_sidepanel',
  [ActionOrigin.SETTINGS_GENERAL_ACCESS_POLICY_PAGE]: 'settings_general_access_policy_page',
  [ActionOrigin.SETTINGS_ASSAY_SCHEMA_PAGE_JSON]: 'settings_assay_schema_page_json',
  [ActionOrigin.SETTINGS_ASSAY_SCHEMA_PAGE_UI]: 'settings_assay_schema_page_ui',
  [ActionOrigin.SETTINGS_BOX_SCHEMA_PAGE]: 'settings_box_schema_page',
  [ActionOrigin.SETTINGS_CONTAINER_SCHEMA_PAGE]: 'settings_container_schema_page',
  [ActionOrigin.SETTINGS_ENTITY_SCHEMA_PAGE]: 'settings_entity_schema_page',
  [ActionOrigin.SETTINGS_CONNECTION_SCHEMA_PAGE]: 'settings_connection_schema_page',
  [ActionOrigin.SETTINGS_INSTRUMENT_GATEWAYS_PAGE]: 'settings_instrument_gateways_page',
  [ActionOrigin.SETTINGS_GENERAL_ACCESS_POLICIES_TABLE]: 'settings_general_access_policies_table',
  [ActionOrigin.SETTINGS_LOCATION_SCHEMA_PAGE]: 'settings_location_schema_page',
  [ActionOrigin.SETTINGS_PLATE_SCHEMA_PAGE]: 'settings_plate_schema_page',
  [ActionOrigin.SETTINGS_PROJECT_MODAL]: 'settings_project_modal',
  [ActionOrigin.SETTINGS_REQUEST_TASK_SCHEMA_PAGE]: 'settings_request_task_schema_page',
  [ActionOrigin.SETTINGS_SCHEMA_INTERFACE_PAGE]: 'settings_schema_interface_page',
  [ActionOrigin.SETTINGS_SCHEMA_INTERFACES_TABLE]: 'settings_schema_interfaces_table',
  [ActionOrigin.SETTINGS_STUDY_SCHEMA_PAGE]: 'settings_study_schema_page',
  [ActionOrigin.SETTINGS_TASK_SCHEMA_PAGE]: 'settings_task_schema_page',
  [ActionOrigin.SETTINGS_TASK_SCHEMA_PAGE_FLOWCHART_CONFIGURATION]: 'settings_task_schema_page_flowchart_configuration',
  [ActionOrigin.SIDEPANEL_FOLDER_CREATE]: 'sidepanel_folder_create',
  [ActionOrigin.SIDEPANEL_GLOBAL_CREATE]: 'sidepanel_global_create',
  [ActionOrigin.SIDEPANEL_HOME_PROCESS_TASK_SUMMARY]: 'sidepanel_home_process_task_summary',
  [ActionOrigin.SIDEPANEL_HOME_WORKLISTS]: 'sidepanel_home_worklists',
  [ActionOrigin.SUCCESS_MESSAGE_POP]: 'success_message_pop',
  [ActionOrigin.SIDEPANEL_UNDETERMINED]: 'sidepanel_undetermined',
  [ActionOrigin.STUDY_CREATION_MODAL]: 'study_creation_modal',
  [ActionOrigin.STUDY_DESIGN_PAGE]: 'study_design_page',
  [ActionOrigin.STUDY_ITEMS_PAGE]: 'study_items_page',
  [ActionOrigin.STUDY_OVERVIEW_PAGE]: 'study_overview_page',
  [ActionOrigin.STUDY_RUN_DETAILS_PAGE]: 'study_run_details_page',
  [ActionOrigin.STUDIES_SIDEPANEL]: 'studies_sidepanel',
  [ActionOrigin.SAMPLE_TESTS_TEST_DEFINITIONS_PAGE]: 'sample_tests_test_definitions_page',
  [ActionOrigin.SAMPLE_TESTS_CREATE_TEST_ORDERS_BUTTON]: 'sample_tests_create_test_orders_button',
  [ActionOrigin.SAMPLE_TESTS_BULK_UPDATE_TEST_ORDER_STATUS_MODAL]: 'sample_tests_bulk_update_test_order_status_modal',
  [ActionOrigin.SAMPLE_TESTS_BULK_UPDATE_TEST_ORDER_CONTAINER_MODAL]: 'sample_tests_bulk_update_test_order_container_modal',
  [ActionOrigin.TENANT_COMPARISON_PAGE]: 'tenant_comparison_page',
  [ActionOrigin.UI_UNDETERMINED]: 'ui_undetermined',
  [ActionOrigin.UNIT_DICTIONARY_PAGE]: 'unit_dictionary_page',
  [ActionOrigin.WORKFLOWS_AUTOMATIC_TRIGGER]: 'workflows_automatic_trigger',
  [ActionOrigin.WORKFLOWS_DASHBOARD]: 'workflows_dashboard',
  [ActionOrigin.WORKFLOWS_DIRECT_EXECUTION_MODAL_WORKFLOW_OUTPUT_TABLE]: 'workflows_direct_execution_modal_workflow_output_table',
  [ActionOrigin.WORKFLOWS_DIRECT_EXECUTION_MODAL_WORKFLOW_TASK_TABLE]: 'workflows_direct_execution_modal_workflow_task_table',
  [ActionOrigin.WORKFLOWS_EXPANDED_SEARCH]: 'workflows_expanded_search',
  [ActionOrigin.WORKFLOWS_EXPANDED_SEARCH_TOOLBAR]: 'workflows_expanded_search_toolbar',
  [ActionOrigin.WORKFLOWS_GRAPH_BUILDER_CANVAS]: 'workflows_graphbuilder_canvas',
  [ActionOrigin.WORKFLOWS_FLOWCHART_FIRST_CONFIGURATION_CANVAS]: 'workflows_flowchart_first_configuration_canvas',
  [ActionOrigin.WORKFLOWS_ROUTER_NODE_CONFIGURATION_MODAL]: 'workflows_router_node_configuration_modal',
  [ActionOrigin.WORKFLOWS_SIDEPANEL_CREATE]: 'workflows_sidepanel_create',
  [ActionOrigin.WORKFLOWS_SINGLETON_SCHEMA_CREATION]: 'workflows_singleton_schema_creation',
  [ActionOrigin.WORKFLOWS_TASK_CREATION_MODAL]: 'workflows_task_creation_modal',
  [ActionOrigin.WORKFLOWS_TASK_CREATION_MODAL_WORKFLOW_TASK_TABLE]: 'workflows_task_creation_modal_workflow_task_table',
  [ActionOrigin.WORKFLOWS_TASK_GROUP_FLOWCHART_PANE]: 'workflows_task_group_flowchart_pane',
  [ActionOrigin.WORKFLOWS_TASK_GROUP_METADATA_TAB]: 'workflows_task_group_metadata_tab',
  [ActionOrigin.WORKFLOWS_TASK_GROUP_PAGE]: 'workflows_task_group_page',
  [ActionOrigin.WORKFLOWS_TASK_GROUP_WORKFLOW_OUTPUT_TABLE]: 'workflows_task_group_workflow_output_table',
  [ActionOrigin.WORKFLOWS_TASK_GROUP_WORKFLOW_TASK_TABLE]: 'workflows_task_group_workflow_task_table',
  [ActionOrigin.WORKFLOWS_TASK_GROUP_CREATION_MODAL_FLOWCHART_PANE]: 'workflows_task_group_creation_modal_flowchart_pane',
  [ActionOrigin.WORKFLOWS_UNDETERMINED_STRUCTURED_TABLE]: 'workflows_structured_table',
  [ActionOrigin.WORKFLOWS_TASK_DETAILS_PAGE]: 'workflows_task_details_page',
  [ActionOrigin.WORKFLOWS_TASK_CREATION_MODAL_INSTRUCTIONS_HEADER]: 'workflows_task_creation_modal_instructions_header',
  [ActionOrigin.WORKFLOWS_TASK_GROUP_INSTRUCTIONS_HEADER]: 'workflows_task_group_instructions_header',
  [ActionOrigin.WORKSHEET]: 'worksheet',
};
export const ACTION_METHOD: Record<ActionMethod, string> = {
  [ActionMethod.ARCHIVE_ROWS_ACTION_FUNCTION]: 'archive_rows_action_function',
  [ActionMethod.AT_CREATION_FLOWCHART_MODIFICATION]: 'at_creation_flowchart_modification',
  [ActionMethod.BANNER_ACTION_CLICK]: 'banner_action_click',
  [ActionMethod.BULK_ACTION]: 'bulk_action',
  [ActionMethod.BULK_REMOVAL_INTERFACE_ARCHIVED]: 'bulk_removal_interface_archived',
  [ActionMethod.BUTTON_CLICK]: 'button_click',
  [ActionMethod.CLONE_FROM_VERSION]: 'clone_from_version',
  [ActionMethod.CREATE_AND_REGISTER]: 'create_and_register',
  [ActionMethod.CREATE_BUTTON]: 'create_button',
  [ActionMethod.CREATE_MODAL]: 'create_modal',
  [ActionMethod.DIRECT_EDIT]: 'direct_edit',
  [ActionMethod.DUPLICATE_RUN_SCHEMA_BUTTON]: 'duplicate_run_schema_button',
  [ActionMethod.CREATE_ENTRY]: 'create_entry',
  [ActionMethod.CREATE_FORM_DEFINITION]: 'create_form_definition',
  [ActionMethod.UPDATE_FORM_DEFINITION]: 'update_form_definition',
  [ActionMethod.GENERATE_AND_SEND_TO_OUTPUT_FILE]: 'generate_and_send_to_output_file',
  [ActionMethod.IMPORT_TRANSFER_DATA]: 'import_transfer_data',
  [ActionMethod.INVENTORY_SHORTCUTS_ACTION_FUNCTION]: 'inventory_shortcuts_action_function',
  [ActionMethod.IN_LINE_EDIT]: 'in_line_edit',
  [ActionMethod.ITEM_RIGHT_CLICK]: 'item_right_click',
  [ActionMethod.LEGACY_TABLE_SUBMISSION]: 'legacy_table_submission',
  [ActionMethod.ADD_FROM_RECENT]: 'add_from_recent',
  [ActionMethod.ADD_FROM_SEARCH]: 'add_from_search',
  [ActionMethod.ADD_FROM_WORKLIST]: 'add_from_worklist',
  [ActionMethod.MANUAL_TABLE_SELECT]: 'manual_table_select',
  [ActionMethod.ONBOARDING_WIZARD]: 'onboarding_wizard',
  [ActionMethod.OTHER]: 'other',
  [ActionMethod.PIPELINES_SET_BY_USER]: 'pipelines_set_by_user',
  [ActionMethod.PIPELINES_SET_AUTOMATICALLY]: 'pipelines_set_automatically',
  [ActionMethod.POST_CREATION_FLOWCHART_MODIFICATION]: 'post_creation_flowchart_modification',
  [ActionMethod.PROCESS_TASK_UNDO_EXECUTION_FUNCTION]: 'process_task_undo_execution_function',
  [ActionMethod.PRINT_BARCODES_ACTION_FUNCTION]: 'print_barcodes_action_function',
  [ActionMethod.PRINT_MIXTURE_GROUP_BARCODE_ACTION_FUNCTION]: 'print_mixture_group_barcode_action_function',
  [ActionMethod.REGISTER_EXISTING_MODAL]: 'register_existing_modal',
  [ActionMethod.RENAME_VERSION]: 'rename_version',
  [ActionMethod.RESET_TO_VERSION]: 'reset_to_version',
  [ActionMethod.REVERT_NOTE]: 'revert_note',
  [ActionMethod.ROUTER_EVALUATION]: 'router_evaluation',
  [ActionMethod.SAMPLE_TESTS_DISCREPANCY_TASK_CALLBACKS]: 'sample_tests_discrepancy_task_callbacks',
  [ActionMethod.SANITIZE_NOTE]: 'sanitize_note',
  [ActionMethod.SCAN_TO_MOVE]: 'scan_to_move',
  [ActionMethod.SETTINGS_EDIT]: 'settings_edit',
  [ActionMethod.SET_FROM_MATRIX_SCANNER]: 'set_from_matrix_scanner',
  [ActionMethod.SINGLE_ACTION]: 'single_action',
  [ActionMethod.SINGLE_REMOVAL]: 'single_removal',
  [ActionMethod.SPREADSHEET_IMPORT]: 'spreadsheet_import',
  [ActionMethod.STAMP_PLATE]: 'stamp_plate',
  [ActionMethod.NOTEBOOK_INSERT_MENU]: 'notebook_insert_menu',
  [ActionMethod.SEND_TO_DOCUMENT_STEP]: 'send_to_document_step',
  [ActionMethod.STRUCTURED_TABLE_COLUMN_MENU]: 'structured_table_column_menu',
  [ActionMethod.STRUCTURED_TABLE_AXIS_DRAG_HANDLE]: 'structured_table_axis_drag_handle',
  [ActionMethod.STRUCTURED_TABLE_FORM_SUBMISSION]: 'structured_table_form_submission',
  [ActionMethod.STRUCTURED_TABLE_MAPPING_CONFIG_SUBMIT]: 'structured_table_mapping_config_submit',
  [ActionMethod.STRUCTURED_TABLE_SUBMISSION]: 'structured_table_submission',
  [ActionMethod.TEMPLATE_FLOWCHART_MODIFICATION]: 'template_flowchart_modification',
  [ActionMethod.UNARCHIVE_ROWS_ACTION_FUNCTION]: 'unarchive_rows_action_function',
  [ActionMethod.UNDO_BUTTON]: 'undo_button',
  [ActionMethod.UPLOAD]: 'upload',
  [ActionMethod.UPSERT_AND_REGISTER]: 'upsert_and_register',
  [ActionMethod.INTERNAL_ADMIN_SCRIPT]: 'internal_admin_script',
};
export const PROCESS_EXECUTION_DISPLAY_NAME_FOR_PROCESSES: Record<ProcessDisplayNameProcesses, string> = {
  [ProcessDisplayNameProcesses.DIRECT]: 'Direct',
  [ProcessDisplayNameProcesses.ENTRY]: 'Entry',
  [ProcessDisplayNameProcesses.FLOWCHART]: 'Flowchart',
  [ProcessDisplayNameProcesses.PIPELINE]: 'Analysis',
};
export const PROCESS_EXECUTION_DISPLAY_NAME_FOR_RECIPES: Record<ProcessDisplayNameRecipes, string> = {
  [ProcessDisplayNameRecipes.PROCEDURE_METHOD]: 'Recipe unit operation',
  [ProcessDisplayNameRecipes.PROCEDURE]: 'Recipe condition replicate run',
  [ProcessDisplayNameRecipes.PROCEDURE_STEP]: 'Recipe step',
};
export const PROCESS_EXECUTION_DISPLAY_NAME_FOR_ASSAYS: Record<ProcessDisplayNameAssays, string> = {
  [ProcessDisplayNameAssays.PROCEDURE_METHOD]: 'Assay unit operation',
  [ProcessDisplayNameAssays.PROCEDURE]: 'Assay condition replicate run',
  [ProcessDisplayNameAssays.PROCEDURE_STEP]: 'Assay step',
};
export const SINGLETON_TASK_SCHEMA_NAME_TO_ENUM_KEY: Record<ProcessSingletonTaskSchemaName, string> = {
  [ProcessSingletonTaskSchemaName.DISCREPANCY_TASK_SCHEMA_NAME]: 'Discrepancy',
  [ProcessSingletonTaskSchemaName.RECIPE_STEP_TASK_SCHEMA_NAME]: 'Benchling Procedure Step Task Schema',
  [ProcessSingletonTaskSchemaName.ASSAY_STEP_TASK_SCHEMA_NAME]: 'Benchling Assay Step Task Schema',
  [ProcessSingletonTaskSchemaName.RECIPE_UNIT_OPERATION_TASK_SCHEMA_NAME]: 'Benchling Recipe Unit Operation',
  [ProcessSingletonTaskSchemaName.ASSAY_UNIT_OPERATION_TASK_SCHEMA_NAME]: 'Benchling Assay Unit Operation',
  [ProcessSingletonTaskSchemaName.PIPELINE_TASK_SCHEMA_NAME]: 'Benchling Pipeline Task Schema',
};
export const ALLOWED_TIMEZONE: Record<AllowedTimezone, string> = {
  [AllowedTimezone.UTC]: 'UTC',
  [AllowedTimezone.US_ALASKA]: 'US/Alaska',
  [AllowedTimezone.US_ARIZONA]: 'US/Arizona',
  [AllowedTimezone.US_CENTRAL]: 'US/Central',
  [AllowedTimezone.US_EASTERN]: 'US/Eastern',
  [AllowedTimezone.US_HAWAII]: 'US/Hawaii',
  [AllowedTimezone.US_MOUNTAIN]: 'US/Mountain',
  [AllowedTimezone.US_PACIFIC]: 'US/Pacific',
  [AllowedTimezone.EUROPE_AMSTERDAM]: 'Europe/Amsterdam',
  [AllowedTimezone.EUROPE_ANDORRA]: 'Europe/Andorra',
  [AllowedTimezone.EUROPE_ASTRAKHAN]: 'Europe/Astrakhan',
  [AllowedTimezone.EUROPE_ATHENS]: 'Europe/Athens',
  [AllowedTimezone.EUROPE_BELGRADE]: 'Europe/Belgrade',
  [AllowedTimezone.EUROPE_BERLIN]: 'Europe/Berlin',
  [AllowedTimezone.EUROPE_BRATISLAVA]: 'Europe/Bratislava',
  [AllowedTimezone.EUROPE_BRUSSELS]: 'Europe/Brussels',
  [AllowedTimezone.EUROPE_BUCHAREST]: 'Europe/Bucharest',
  [AllowedTimezone.EUROPE_BUDAPEST]: 'Europe/Budapest',
  [AllowedTimezone.EUROPE_BUSINGEN]: 'Europe/Busingen',
  [AllowedTimezone.EUROPE_CHISINAU]: 'Europe/Chisinau',
  [AllowedTimezone.EUROPE_COPENHAGEN]: 'Europe/Copenhagen',
  [AllowedTimezone.EUROPE_DUBLIN]: 'Europe/Dublin',
  [AllowedTimezone.EUROPE_GIBRALTAR]: 'Europe/Gibraltar',
  [AllowedTimezone.EUROPE_GUERNSEY]: 'Europe/Guernsey',
  [AllowedTimezone.EUROPE_HELSINKI]: 'Europe/Helsinki',
  [AllowedTimezone.EUROPE_ISLE_OF_MAN]: 'Europe/Isle_of_Man',
  [AllowedTimezone.EUROPE_ISTANBUL]: 'Europe/Istanbul',
  [AllowedTimezone.EUROPE_JERSEY]: 'Europe/Jersey',
  [AllowedTimezone.EUROPE_KALININGRAD]: 'Europe/Kaliningrad',
  [AllowedTimezone.EUROPE_KIROV]: 'Europe/Kirov',
  [AllowedTimezone.EUROPE_KYIV]: 'Europe/Kyiv',
  [AllowedTimezone.EUROPE_LISBON]: 'Europe/Lisbon',
  [AllowedTimezone.EUROPE_LJUBLJANA]: 'Europe/Ljubljana',
  [AllowedTimezone.EUROPE_LONDON]: 'Europe/London',
  [AllowedTimezone.EUROPE_LUXEMBOURG]: 'Europe/Luxembourg',
  [AllowedTimezone.EUROPE_MADRID]: 'Europe/Madrid',
  [AllowedTimezone.EUROPE_MALTA]: 'Europe/Malta',
  [AllowedTimezone.EUROPE_MARIEHAMN]: 'Europe/Mariehamn',
  [AllowedTimezone.EUROPE_MINSK]: 'Europe/Minsk',
  [AllowedTimezone.EUROPE_MONACO]: 'Europe/Monaco',
  [AllowedTimezone.EUROPE_MOSCOW]: 'Europe/Moscow',
  [AllowedTimezone.EUROPE_OSLO]: 'Europe/Oslo',
  [AllowedTimezone.EUROPE_PARIS]: 'Europe/Paris',
  [AllowedTimezone.EUROPE_PODGORICA]: 'Europe/Podgorica',
  [AllowedTimezone.EUROPE_PRAGUE]: 'Europe/Prague',
  [AllowedTimezone.EUROPE_RIGA]: 'Europe/Riga',
  [AllowedTimezone.EUROPE_ROME]: 'Europe/Rome',
  [AllowedTimezone.EUROPE_SAMARA]: 'Europe/Samara',
  [AllowedTimezone.EUROPE_SAN_MARINO]: 'Europe/San_Marino',
  [AllowedTimezone.EUROPE_SARAJEVO]: 'Europe/Sarajevo',
  [AllowedTimezone.EUROPE_SARATOV]: 'Europe/Saratov',
  [AllowedTimezone.EUROPE_SIMFEROPOL]: 'Europe/Simferopol',
  [AllowedTimezone.EUROPE_SKOPJE]: 'Europe/Skopje',
  [AllowedTimezone.EUROPE_SOFIA]: 'Europe/Sofia',
  [AllowedTimezone.EUROPE_STOCKHOLM]: 'Europe/Stockholm',
  [AllowedTimezone.EUROPE_TALLINN]: 'Europe/Tallinn',
  [AllowedTimezone.EUROPE_TIRANE]: 'Europe/Tirane',
  [AllowedTimezone.EUROPE_ULYANOVSK]: 'Europe/Ulyanovsk',
  [AllowedTimezone.EUROPE_VADUZ]: 'Europe/Vaduz',
  [AllowedTimezone.EUROPE_VATICAN]: 'Europe/Vatican',
  [AllowedTimezone.EUROPE_VIENNA]: 'Europe/Vienna',
  [AllowedTimezone.EUROPE_VILNIUS]: 'Europe/Vilnius',
  [AllowedTimezone.EUROPE_VOLGOGRAD]: 'Europe/Volgograd',
  [AllowedTimezone.EUROPE_WARSAW]: 'Europe/Warsaw',
  [AllowedTimezone.EUROPE_ZAGREB]: 'Europe/Zagreb',
  [AllowedTimezone.EUROPE_ZURICH]: 'Europe/Zurich',
  [AllowedTimezone.AFRICA_ABIDJAN]: 'Africa/Abidjan',
  [AllowedTimezone.AFRICA_ACCRA]: 'Africa/Accra',
  [AllowedTimezone.AFRICA_ADDIS_ABABA]: 'Africa/Addis_Ababa',
  [AllowedTimezone.AFRICA_ALGIERS]: 'Africa/Algiers',
  [AllowedTimezone.AFRICA_ASMARA]: 'Africa/Asmara',
  [AllowedTimezone.AFRICA_BAMAKO]: 'Africa/Bamako',
  [AllowedTimezone.AFRICA_BANGUI]: 'Africa/Bangui',
  [AllowedTimezone.AFRICA_BANJUL]: 'Africa/Banjul',
  [AllowedTimezone.AFRICA_BISSAU]: 'Africa/Bissau',
  [AllowedTimezone.AFRICA_BLANTYRE]: 'Africa/Blantyre',
  [AllowedTimezone.AFRICA_BRAZZAVILLE]: 'Africa/Brazzaville',
  [AllowedTimezone.AFRICA_BUJUMBURA]: 'Africa/Bujumbura',
  [AllowedTimezone.AFRICA_CAIRO]: 'Africa/Cairo',
  [AllowedTimezone.AFRICA_CASABLANCA]: 'Africa/Casablanca',
  [AllowedTimezone.AFRICA_CEUTA]: 'Africa/Ceuta',
  [AllowedTimezone.AFRICA_CONAKRY]: 'Africa/Conakry',
  [AllowedTimezone.AFRICA_DAKAR]: 'Africa/Dakar',
  [AllowedTimezone.AFRICA_DAR_ES_SALAAM]: 'Africa/Dar_es_Salaam',
  [AllowedTimezone.AFRICA_DJIBOUTI]: 'Africa/Djibouti',
  [AllowedTimezone.AFRICA_DOUALA]: 'Africa/Douala',
  [AllowedTimezone.AFRICA_EL_AAIUN]: 'Africa/El_Aaiun',
  [AllowedTimezone.AFRICA_FREETOWN]: 'Africa/Freetown',
  [AllowedTimezone.AFRICA_GABORONE]: 'Africa/Gaborone',
  [AllowedTimezone.AFRICA_HARARE]: 'Africa/Harare',
  [AllowedTimezone.AFRICA_JOHANNESBURG]: 'Africa/Johannesburg',
  [AllowedTimezone.AFRICA_JUBA]: 'Africa/Juba',
  [AllowedTimezone.AFRICA_KAMPALA]: 'Africa/Kampala',
  [AllowedTimezone.AFRICA_KHARTOUM]: 'Africa/Khartoum',
  [AllowedTimezone.AFRICA_KIGALI]: 'Africa/Kigali',
  [AllowedTimezone.AFRICA_KINSHASA]: 'Africa/Kinshasa',
  [AllowedTimezone.AFRICA_LAGOS]: 'Africa/Lagos',
  [AllowedTimezone.AFRICA_LIBREVILLE]: 'Africa/Libreville',
  [AllowedTimezone.AFRICA_LOME]: 'Africa/Lome',
  [AllowedTimezone.AFRICA_LUANDA]: 'Africa/Luanda',
  [AllowedTimezone.AFRICA_LUBUMBASHI]: 'Africa/Lubumbashi',
  [AllowedTimezone.AFRICA_LUSAKA]: 'Africa/Lusaka',
  [AllowedTimezone.AFRICA_MALABO]: 'Africa/Malabo',
  [AllowedTimezone.AFRICA_MAPUTO]: 'Africa/Maputo',
  [AllowedTimezone.AFRICA_MASERU]: 'Africa/Maseru',
  [AllowedTimezone.AFRICA_MBABANE]: 'Africa/Mbabane',
  [AllowedTimezone.AFRICA_MOGADISHU]: 'Africa/Mogadishu',
  [AllowedTimezone.AFRICA_MONROVIA]: 'Africa/Monrovia',
  [AllowedTimezone.AFRICA_NAIROBI]: 'Africa/Nairobi',
  [AllowedTimezone.AFRICA_NDJAMENA]: 'Africa/Ndjamena',
  [AllowedTimezone.AFRICA_NIAMEY]: 'Africa/Niamey',
  [AllowedTimezone.AFRICA_NOUAKCHOTT]: 'Africa/Nouakchott',
  [AllowedTimezone.AFRICA_OUAGADOUGOU]: 'Africa/Ouagadougou',
  [AllowedTimezone.AFRICA_PORTO_NOVO]: 'Africa/Porto-Novo',
  [AllowedTimezone.AFRICA_SAO_TOME]: 'Africa/Sao_Tome',
  [AllowedTimezone.AFRICA_TRIPOLI]: 'Africa/Tripoli',
  [AllowedTimezone.AFRICA_TUNIS]: 'Africa/Tunis',
  [AllowedTimezone.AFRICA_WINDHOEK]: 'Africa/Windhoek',
  [AllowedTimezone.AMERICA_ADAK]: 'America/Adak',
  [AllowedTimezone.AMERICA_ANCHORAGE]: 'America/Anchorage',
  [AllowedTimezone.AMERICA_ANGUILLA]: 'America/Anguilla',
  [AllowedTimezone.AMERICA_ANTIGUA]: 'America/Antigua',
  [AllowedTimezone.AMERICA_ARAGUAINA]: 'America/Araguaina',
  [AllowedTimezone.AMERICA_ARGENTINA_BUENOS_AIRES]: 'America/Argentina/Buenos_Aires',
  [AllowedTimezone.AMERICA_ARGENTINA_CATAMARCA]: 'America/Argentina/Catamarca',
  [AllowedTimezone.AMERICA_ARGENTINA_CORDOBA]: 'America/Argentina/Cordoba',
  [AllowedTimezone.AMERICA_ARGENTINA_JUJUY]: 'America/Argentina/Jujuy',
  [AllowedTimezone.AMERICA_ARGENTINA_LA_RIOJA]: 'America/Argentina/La_Rioja',
  [AllowedTimezone.AMERICA_ARGENTINA_MENDOZA]: 'America/Argentina/Mendoza',
  [AllowedTimezone.AMERICA_ARGENTINA_RIO_GALLEGOS]: 'America/Argentina/Rio_Gallegos',
  [AllowedTimezone.AMERICA_ARGENTINA_SALTA]: 'America/Argentina/Salta',
  [AllowedTimezone.AMERICA_ARGENTINA_SAN_JUAN]: 'America/Argentina/San_Juan',
  [AllowedTimezone.AMERICA_ARGENTINA_SAN_LUIS]: 'America/Argentina/San_Luis',
  [AllowedTimezone.AMERICA_ARGENTINA_TUCUMAN]: 'America/Argentina/Tucuman',
  [AllowedTimezone.AMERICA_ARGENTINA_USHUAIA]: 'America/Argentina/Ushuaia',
  [AllowedTimezone.AMERICA_ARUBA]: 'America/Aruba',
  [AllowedTimezone.AMERICA_ASUNCION]: 'America/Asuncion',
  [AllowedTimezone.AMERICA_ATIKOKAN]: 'America/Atikokan',
  [AllowedTimezone.AMERICA_BAHIA]: 'America/Bahia',
  [AllowedTimezone.AMERICA_BAHIA_BANDERAS]: 'America/Bahia_Banderas',
  [AllowedTimezone.AMERICA_BARBADOS]: 'America/Barbados',
  [AllowedTimezone.AMERICA_BELEM]: 'America/Belem',
  [AllowedTimezone.AMERICA_BELIZE]: 'America/Belize',
  [AllowedTimezone.AMERICA_BLANC_SABLON]: 'America/Blanc-Sablon',
  [AllowedTimezone.AMERICA_BOA_VISTA]: 'America/Boa_Vista',
  [AllowedTimezone.AMERICA_BOGOTA]: 'America/Bogota',
  [AllowedTimezone.AMERICA_BOISE]: 'America/Boise',
  [AllowedTimezone.AMERICA_CAMBRIDGE_BAY]: 'America/Cambridge_Bay',
  [AllowedTimezone.AMERICA_CAMPO_GRANDE]: 'America/Campo_Grande',
  [AllowedTimezone.AMERICA_CANCUN]: 'America/Cancun',
  [AllowedTimezone.AMERICA_CARACAS]: 'America/Caracas',
  [AllowedTimezone.AMERICA_CAYENNE]: 'America/Cayenne',
  [AllowedTimezone.AMERICA_CAYMAN]: 'America/Cayman',
  [AllowedTimezone.AMERICA_CHICAGO]: 'America/Chicago',
  [AllowedTimezone.AMERICA_CHIHUAHUA]: 'America/Chihuahua',
  [AllowedTimezone.AMERICA_CIUDAD_JUAREZ]: 'America/Ciudad_Juarez',
  [AllowedTimezone.AMERICA_COSTA_RICA]: 'America/Costa_Rica',
  [AllowedTimezone.AMERICA_CRESTON]: 'America/Creston',
  [AllowedTimezone.AMERICA_CUIABA]: 'America/Cuiaba',
  [AllowedTimezone.AMERICA_CURACAO]: 'America/Curacao',
  [AllowedTimezone.AMERICA_DANMARKSHAVN]: 'America/Danmarkshavn',
  [AllowedTimezone.AMERICA_DAWSON]: 'America/Dawson',
  [AllowedTimezone.AMERICA_DAWSON_CREEK]: 'America/Dawson_Creek',
  [AllowedTimezone.AMERICA_DENVER]: 'America/Denver',
  [AllowedTimezone.AMERICA_DETROIT]: 'America/Detroit',
  [AllowedTimezone.AMERICA_DOMINICA]: 'America/Dominica',
  [AllowedTimezone.AMERICA_EDMONTON]: 'America/Edmonton',
  [AllowedTimezone.AMERICA_EIRUNEPE]: 'America/Eirunepe',
  [AllowedTimezone.AMERICA_EL_SALVADOR]: 'America/El_Salvador',
  [AllowedTimezone.AMERICA_FORT_NELSON]: 'America/Fort_Nelson',
  [AllowedTimezone.AMERICA_FORTALEZA]: 'America/Fortaleza',
  [AllowedTimezone.AMERICA_GLACE_BAY]: 'America/Glace_Bay',
  [AllowedTimezone.AMERICA_GOOSE_BAY]: 'America/Goose_Bay',
  [AllowedTimezone.AMERICA_GRAND_TURK]: 'America/Grand_Turk',
  [AllowedTimezone.AMERICA_GRENADA]: 'America/Grenada',
  [AllowedTimezone.AMERICA_GUADELOUPE]: 'America/Guadeloupe',
  [AllowedTimezone.AMERICA_GUATEMALA]: 'America/Guatemala',
  [AllowedTimezone.AMERICA_GUAYAQUIL]: 'America/Guayaquil',
  [AllowedTimezone.AMERICA_GUYANA]: 'America/Guyana',
  [AllowedTimezone.AMERICA_HALIFAX]: 'America/Halifax',
  [AllowedTimezone.AMERICA_HAVANA]: 'America/Havana',
  [AllowedTimezone.AMERICA_HERMOSILLO]: 'America/Hermosillo',
  [AllowedTimezone.AMERICA_INDIANA_INDIANAPOLIS]: 'America/Indiana/Indianapolis',
  [AllowedTimezone.AMERICA_INDIANA_KNOX]: 'America/Indiana/Knox',
  [AllowedTimezone.AMERICA_INDIANA_MARENGO]: 'America/Indiana/Marengo',
  [AllowedTimezone.AMERICA_INDIANA_PETERSBURG]: 'America/Indiana/Petersburg',
  [AllowedTimezone.AMERICA_INDIANA_TELL_CITY]: 'America/Indiana/Tell_City',
  [AllowedTimezone.AMERICA_INDIANA_VEVAY]: 'America/Indiana/Vevay',
  [AllowedTimezone.AMERICA_INDIANA_VINCENNES]: 'America/Indiana/Vincennes',
  [AllowedTimezone.AMERICA_INDIANA_WINAMAC]: 'America/Indiana/Winamac',
  [AllowedTimezone.AMERICA_INUVIK]: 'America/Inuvik',
  [AllowedTimezone.AMERICA_IQALUIT]: 'America/Iqaluit',
  [AllowedTimezone.AMERICA_JAMAICA]: 'America/Jamaica',
  [AllowedTimezone.AMERICA_JUNEAU]: 'America/Juneau',
  [AllowedTimezone.AMERICA_KENTUCKY_LOUISVILLE]: 'America/Kentucky/Louisville',
  [AllowedTimezone.AMERICA_KENTUCKY_MONTICELLO]: 'America/Kentucky/Monticello',
  [AllowedTimezone.AMERICA_KRALENDIJK]: 'America/Kralendijk',
  [AllowedTimezone.AMERICA_LA_PAZ]: 'America/La_Paz',
  [AllowedTimezone.AMERICA_LIMA]: 'America/Lima',
  [AllowedTimezone.AMERICA_LOS_ANGELES]: 'America/Los_Angeles',
  [AllowedTimezone.AMERICA_LOWER_PRINCES]: 'America/Lower_Princes',
  [AllowedTimezone.AMERICA_MACEIO]: 'America/Maceio',
  [AllowedTimezone.AMERICA_MANAGUA]: 'America/Managua',
  [AllowedTimezone.AMERICA_MANAUS]: 'America/Manaus',
  [AllowedTimezone.AMERICA_MARIGOT]: 'America/Marigot',
  [AllowedTimezone.AMERICA_MARTINIQUE]: 'America/Martinique',
  [AllowedTimezone.AMERICA_MATAMOROS]: 'America/Matamoros',
  [AllowedTimezone.AMERICA_MAZATLAN]: 'America/Mazatlan',
  [AllowedTimezone.AMERICA_MENOMINEE]: 'America/Menominee',
  [AllowedTimezone.AMERICA_MERIDA]: 'America/Merida',
  [AllowedTimezone.AMERICA_METLAKATLA]: 'America/Metlakatla',
  [AllowedTimezone.AMERICA_MEXICO_CITY]: 'America/Mexico_City',
  [AllowedTimezone.AMERICA_MIQUELON]: 'America/Miquelon',
  [AllowedTimezone.AMERICA_MONCTON]: 'America/Moncton',
  [AllowedTimezone.AMERICA_MONTERREY]: 'America/Monterrey',
  [AllowedTimezone.AMERICA_MONTEVIDEO]: 'America/Montevideo',
  [AllowedTimezone.AMERICA_MONTSERRAT]: 'America/Montserrat',
  [AllowedTimezone.AMERICA_NASSAU]: 'America/Nassau',
  [AllowedTimezone.AMERICA_NEW_YORK]: 'America/New_York',
  [AllowedTimezone.AMERICA_NOME]: 'America/Nome',
  [AllowedTimezone.AMERICA_NORONHA]: 'America/Noronha',
  [AllowedTimezone.AMERICA_NORTH_DAKOTA_BEULAH]: 'America/North_Dakota/Beulah',
  [AllowedTimezone.AMERICA_NORTH_DAKOTA_CENTER]: 'America/North_Dakota/Center',
  [AllowedTimezone.AMERICA_NORTH_DAKOTA_NEW_SALEM]: 'America/North_Dakota/New_Salem',
  [AllowedTimezone.AMERICA_NUUK]: 'America/Nuuk',
  [AllowedTimezone.AMERICA_OJINAGA]: 'America/Ojinaga',
  [AllowedTimezone.AMERICA_PANAMA]: 'America/Panama',
  [AllowedTimezone.AMERICA_PARAMARIBO]: 'America/Paramaribo',
  [AllowedTimezone.AMERICA_PHOENIX]: 'America/Phoenix',
  [AllowedTimezone.AMERICA_PORT_AU_PRINCE]: 'America/Port-au-Prince',
  [AllowedTimezone.AMERICA_PORT_OF_SPAIN]: 'America/Port_of_Spain',
  [AllowedTimezone.AMERICA_PORTO_VELHO]: 'America/Porto_Velho',
  [AllowedTimezone.AMERICA_PUERTO_RICO]: 'America/Puerto_Rico',
  [AllowedTimezone.AMERICA_PUNTA_ARENAS]: 'America/Punta_Arenas',
  [AllowedTimezone.AMERICA_RANKIN_INLET]: 'America/Rankin_Inlet',
  [AllowedTimezone.AMERICA_RECIFE]: 'America/Recife',
  [AllowedTimezone.AMERICA_REGINA]: 'America/Regina',
  [AllowedTimezone.AMERICA_RESOLUTE]: 'America/Resolute',
  [AllowedTimezone.AMERICA_RIO_BRANCO]: 'America/Rio_Branco',
  [AllowedTimezone.AMERICA_SANTAREM]: 'America/Santarem',
  [AllowedTimezone.AMERICA_SANTIAGO]: 'America/Santiago',
  [AllowedTimezone.AMERICA_SANTO_DOMINGO]: 'America/Santo_Domingo',
  [AllowedTimezone.AMERICA_SAO_PAULO]: 'America/Sao_Paulo',
  [AllowedTimezone.AMERICA_SCORESBYSUND]: 'America/Scoresbysund',
  [AllowedTimezone.AMERICA_SITKA]: 'America/Sitka',
  [AllowedTimezone.AMERICA_ST_BARTHELEMY]: 'America/St_Barthelemy',
  [AllowedTimezone.AMERICA_ST_JOHNS]: 'America/St_Johns',
  [AllowedTimezone.AMERICA_ST_KITTS]: 'America/St_Kitts',
  [AllowedTimezone.AMERICA_ST_LUCIA]: 'America/St_Lucia',
  [AllowedTimezone.AMERICA_ST_THOMAS]: 'America/St_Thomas',
  [AllowedTimezone.AMERICA_ST_VINCENT]: 'America/St_Vincent',
  [AllowedTimezone.AMERICA_SWIFT_CURRENT]: 'America/Swift_Current',
  [AllowedTimezone.AMERICA_TEGUCIGALPA]: 'America/Tegucigalpa',
  [AllowedTimezone.AMERICA_THULE]: 'America/Thule',
  [AllowedTimezone.AMERICA_TIJUANA]: 'America/Tijuana',
  [AllowedTimezone.AMERICA_TORONTO]: 'America/Toronto',
  [AllowedTimezone.AMERICA_TORTOLA]: 'America/Tortola',
  [AllowedTimezone.AMERICA_VANCOUVER]: 'America/Vancouver',
  [AllowedTimezone.AMERICA_WHITEHORSE]: 'America/Whitehorse',
  [AllowedTimezone.AMERICA_WINNIPEG]: 'America/Winnipeg',
  [AllowedTimezone.AMERICA_YAKUTAT]: 'America/Yakutat',
  [AllowedTimezone.ANTARCTICA_CASEY]: 'Antarctica/Casey',
  [AllowedTimezone.ANTARCTICA_DAVIS]: 'Antarctica/Davis',
  [AllowedTimezone.ANTARCTICA_DUMONTDURVILLE]: 'Antarctica/DumontDUrville',
  [AllowedTimezone.ANTARCTICA_MACQUARIE]: 'Antarctica/Macquarie',
  [AllowedTimezone.ANTARCTICA_MAWSON]: 'Antarctica/Mawson',
  [AllowedTimezone.ANTARCTICA_MCMURDO]: 'Antarctica/McMurdo',
  [AllowedTimezone.ANTARCTICA_PALMER]: 'Antarctica/Palmer',
  [AllowedTimezone.ANTARCTICA_ROTHERA]: 'Antarctica/Rothera',
  [AllowedTimezone.ANTARCTICA_SYOWA]: 'Antarctica/Syowa',
  [AllowedTimezone.ANTARCTICA_TROLL]: 'Antarctica/Troll',
  [AllowedTimezone.ANTARCTICA_VOSTOK]: 'Antarctica/Vostok',
  [AllowedTimezone.ARCTIC_LONGYEARBYEN]: 'Arctic/Longyearbyen',
  [AllowedTimezone.ASIA_ADEN]: 'Asia/Aden',
  [AllowedTimezone.ASIA_ALMATY]: 'Asia/Almaty',
  [AllowedTimezone.ASIA_AMMAN]: 'Asia/Amman',
  [AllowedTimezone.ASIA_ANADYR]: 'Asia/Anadyr',
  [AllowedTimezone.ASIA_AQTAU]: 'Asia/Aqtau',
  [AllowedTimezone.ASIA_AQTOBE]: 'Asia/Aqtobe',
  [AllowedTimezone.ASIA_ASHGABAT]: 'Asia/Ashgabat',
  [AllowedTimezone.ASIA_ATYRAU]: 'Asia/Atyrau',
  [AllowedTimezone.ASIA_BAGHDAD]: 'Asia/Baghdad',
  [AllowedTimezone.ASIA_BAHRAIN]: 'Asia/Bahrain',
  [AllowedTimezone.ASIA_BAKU]: 'Asia/Baku',
  [AllowedTimezone.ASIA_BANGKOK]: 'Asia/Bangkok',
  [AllowedTimezone.ASIA_BARNAUL]: 'Asia/Barnaul',
  [AllowedTimezone.ASIA_BEIRUT]: 'Asia/Beirut',
  [AllowedTimezone.ASIA_BISHKEK]: 'Asia/Bishkek',
  [AllowedTimezone.ASIA_BRUNEI]: 'Asia/Brunei',
  [AllowedTimezone.ASIA_CHITA]: 'Asia/Chita',
  [AllowedTimezone.ASIA_CHOIBALSAN]: 'Asia/Choibalsan',
  [AllowedTimezone.ASIA_COLOMBO]: 'Asia/Colombo',
  [AllowedTimezone.ASIA_DAMASCUS]: 'Asia/Damascus',
  [AllowedTimezone.ASIA_DHAKA]: 'Asia/Dhaka',
  [AllowedTimezone.ASIA_DILI]: 'Asia/Dili',
  [AllowedTimezone.ASIA_DUBAI]: 'Asia/Dubai',
  [AllowedTimezone.ASIA_DUSHANBE]: 'Asia/Dushanbe',
  [AllowedTimezone.ASIA_FAMAGUSTA]: 'Asia/Famagusta',
  [AllowedTimezone.ASIA_GAZA]: 'Asia/Gaza',
  [AllowedTimezone.ASIA_HEBRON]: 'Asia/Hebron',
  [AllowedTimezone.ASIA_HO_CHI_MINH]: 'Asia/Ho_Chi_Minh',
  [AllowedTimezone.ASIA_HONG_KONG]: 'Asia/Hong_Kong',
  [AllowedTimezone.ASIA_HOVD]: 'Asia/Hovd',
  [AllowedTimezone.ASIA_IRKUTSK]: 'Asia/Irkutsk',
  [AllowedTimezone.ASIA_JAKARTA]: 'Asia/Jakarta',
  [AllowedTimezone.ASIA_JAYAPURA]: 'Asia/Jayapura',
  [AllowedTimezone.ASIA_JERUSALEM]: 'Asia/Jerusalem',
  [AllowedTimezone.ASIA_KABUL]: 'Asia/Kabul',
  [AllowedTimezone.ASIA_KAMCHATKA]: 'Asia/Kamchatka',
  [AllowedTimezone.ASIA_KARACHI]: 'Asia/Karachi',
  [AllowedTimezone.ASIA_KATHMANDU]: 'Asia/Kathmandu',
  [AllowedTimezone.ASIA_KHANDYGA]: 'Asia/Khandyga',
  [AllowedTimezone.ASIA_KOLKATA]: 'Asia/Kolkata',
  [AllowedTimezone.ASIA_KRASNOYARSK]: 'Asia/Krasnoyarsk',
  [AllowedTimezone.ASIA_KUALA_LUMPUR]: 'Asia/Kuala_Lumpur',
  [AllowedTimezone.ASIA_KUCHING]: 'Asia/Kuching',
  [AllowedTimezone.ASIA_KUWAIT]: 'Asia/Kuwait',
  [AllowedTimezone.ASIA_MACAU]: 'Asia/Macau',
  [AllowedTimezone.ASIA_MAGADAN]: 'Asia/Magadan',
  [AllowedTimezone.ASIA_MAKASSAR]: 'Asia/Makassar',
  [AllowedTimezone.ASIA_MANILA]: 'Asia/Manila',
  [AllowedTimezone.ASIA_MUSCAT]: 'Asia/Muscat',
  [AllowedTimezone.ASIA_NICOSIA]: 'Asia/Nicosia',
  [AllowedTimezone.ASIA_NOVOKUZNETSK]: 'Asia/Novokuznetsk',
  [AllowedTimezone.ASIA_NOVOSIBIRSK]: 'Asia/Novosibirsk',
  [AllowedTimezone.ASIA_OMSK]: 'Asia/Omsk',
  [AllowedTimezone.ASIA_ORAL]: 'Asia/Oral',
  [AllowedTimezone.ASIA_PHNOM_PENH]: 'Asia/Phnom_Penh',
  [AllowedTimezone.ASIA_PONTIANAK]: 'Asia/Pontianak',
  [AllowedTimezone.ASIA_PYONGYANG]: 'Asia/Pyongyang',
  [AllowedTimezone.ASIA_QATAR]: 'Asia/Qatar',
  [AllowedTimezone.ASIA_QOSTANAY]: 'Asia/Qostanay',
  [AllowedTimezone.ASIA_QYZYLORDA]: 'Asia/Qyzylorda',
  [AllowedTimezone.ASIA_RIYADH]: 'Asia/Riyadh',
  [AllowedTimezone.ASIA_SAKHALIN]: 'Asia/Sakhalin',
  [AllowedTimezone.ASIA_SAMARKAND]: 'Asia/Samarkand',
  [AllowedTimezone.ASIA_SEOUL]: 'Asia/Seoul',
  [AllowedTimezone.ASIA_SHANGHAI]: 'Asia/Shanghai',
  [AllowedTimezone.ASIA_SINGAPORE]: 'Asia/Singapore',
  [AllowedTimezone.ASIA_SREDNEKOLYMSK]: 'Asia/Srednekolymsk',
  [AllowedTimezone.ASIA_TAIPEI]: 'Asia/Taipei',
  [AllowedTimezone.ASIA_TASHKENT]: 'Asia/Tashkent',
  [AllowedTimezone.ASIA_TBILISI]: 'Asia/Tbilisi',
  [AllowedTimezone.ASIA_TEHRAN]: 'Asia/Tehran',
  [AllowedTimezone.ASIA_THIMPHU]: 'Asia/Thimphu',
  [AllowedTimezone.ASIA_TOKYO]: 'Asia/Tokyo',
  [AllowedTimezone.ASIA_TOMSK]: 'Asia/Tomsk',
  [AllowedTimezone.ASIA_ULAANBAATAR]: 'Asia/Ulaanbaatar',
  [AllowedTimezone.ASIA_URUMQI]: 'Asia/Urumqi',
  [AllowedTimezone.ASIA_UST_NERA]: 'Asia/Ust-Nera',
  [AllowedTimezone.ASIA_VIENTIANE]: 'Asia/Vientiane',
  [AllowedTimezone.ASIA_VLADIVOSTOK]: 'Asia/Vladivostok',
  [AllowedTimezone.ASIA_YAKUTSK]: 'Asia/Yakutsk',
  [AllowedTimezone.ASIA_YANGON]: 'Asia/Yangon',
  [AllowedTimezone.ASIA_YEKATERINBURG]: 'Asia/Yekaterinburg',
  [AllowedTimezone.ASIA_YEREVAN]: 'Asia/Yerevan',
  [AllowedTimezone.ATLANTIC_AZORES]: 'Atlantic/Azores',
  [AllowedTimezone.ATLANTIC_BERMUDA]: 'Atlantic/Bermuda',
  [AllowedTimezone.ATLANTIC_CANARY]: 'Atlantic/Canary',
  [AllowedTimezone.ATLANTIC_CAPE_VERDE]: 'Atlantic/Cape_Verde',
  [AllowedTimezone.ATLANTIC_FAROE]: 'Atlantic/Faroe',
  [AllowedTimezone.ATLANTIC_MADEIRA]: 'Atlantic/Madeira',
  [AllowedTimezone.ATLANTIC_REYKJAVIK]: 'Atlantic/Reykjavik',
  [AllowedTimezone.ATLANTIC_SOUTH_GEORGIA]: 'Atlantic/South_Georgia',
  [AllowedTimezone.ATLANTIC_ST_HELENA]: 'Atlantic/St_Helena',
  [AllowedTimezone.ATLANTIC_STANLEY]: 'Atlantic/Stanley',
  [AllowedTimezone.AUSTRALIA_ADELAIDE]: 'Australia/Adelaide',
  [AllowedTimezone.AUSTRALIA_BRISBANE]: 'Australia/Brisbane',
  [AllowedTimezone.AUSTRALIA_BROKEN_HILL]: 'Australia/Broken_Hill',
  [AllowedTimezone.AUSTRALIA_DARWIN]: 'Australia/Darwin',
  [AllowedTimezone.AUSTRALIA_EUCLA]: 'Australia/Eucla',
  [AllowedTimezone.AUSTRALIA_HOBART]: 'Australia/Hobart',
  [AllowedTimezone.AUSTRALIA_LINDEMAN]: 'Australia/Lindeman',
  [AllowedTimezone.AUSTRALIA_LORD_HOWE]: 'Australia/Lord_Howe',
  [AllowedTimezone.AUSTRALIA_MELBOURNE]: 'Australia/Melbourne',
  [AllowedTimezone.AUSTRALIA_PERTH]: 'Australia/Perth',
  [AllowedTimezone.AUSTRALIA_SYDNEY]: 'Australia/Sydney',
  [AllowedTimezone.CANADA_ATLANTIC]: 'Canada/Atlantic',
  [AllowedTimezone.CANADA_CENTRAL]: 'Canada/Central',
  [AllowedTimezone.CANADA_EASTERN]: 'Canada/Eastern',
  [AllowedTimezone.CANADA_MOUNTAIN]: 'Canada/Mountain',
  [AllowedTimezone.CANADA_NEWFOUNDLAND]: 'Canada/Newfoundland',
  [AllowedTimezone.CANADA_PACIFIC]: 'Canada/Pacific',
  [AllowedTimezone.GMT]: 'GMT',
  [AllowedTimezone.INDIAN_ANTANANARIVO]: 'Indian/Antananarivo',
  [AllowedTimezone.INDIAN_CHAGOS]: 'Indian/Chagos',
  [AllowedTimezone.INDIAN_CHRISTMAS]: 'Indian/Christmas',
  [AllowedTimezone.INDIAN_COCOS]: 'Indian/Cocos',
  [AllowedTimezone.INDIAN_COMORO]: 'Indian/Comoro',
  [AllowedTimezone.INDIAN_KERGUELEN]: 'Indian/Kerguelen',
  [AllowedTimezone.INDIAN_MAHE]: 'Indian/Mahe',
  [AllowedTimezone.INDIAN_MALDIVES]: 'Indian/Maldives',
  [AllowedTimezone.INDIAN_MAURITIUS]: 'Indian/Mauritius',
  [AllowedTimezone.INDIAN_MAYOTTE]: 'Indian/Mayotte',
  [AllowedTimezone.INDIAN_REUNION]: 'Indian/Reunion',
  [AllowedTimezone.PACIFIC_APIA]: 'Pacific/Apia',
  [AllowedTimezone.PACIFIC_AUCKLAND]: 'Pacific/Auckland',
  [AllowedTimezone.PACIFIC_BOUGAINVILLE]: 'Pacific/Bougainville',
  [AllowedTimezone.PACIFIC_CHATHAM]: 'Pacific/Chatham',
  [AllowedTimezone.PACIFIC_CHUUK]: 'Pacific/Chuuk',
  [AllowedTimezone.PACIFIC_EASTER]: 'Pacific/Easter',
  [AllowedTimezone.PACIFIC_EFATE]: 'Pacific/Efate',
  [AllowedTimezone.PACIFIC_FAKAOFO]: 'Pacific/Fakaofo',
  [AllowedTimezone.PACIFIC_FIJI]: 'Pacific/Fiji',
  [AllowedTimezone.PACIFIC_FUNAFUTI]: 'Pacific/Funafuti',
  [AllowedTimezone.PACIFIC_GALAPAGOS]: 'Pacific/Galapagos',
  [AllowedTimezone.PACIFIC_GAMBIER]: 'Pacific/Gambier',
  [AllowedTimezone.PACIFIC_GUADALCANAL]: 'Pacific/Guadalcanal',
  [AllowedTimezone.PACIFIC_GUAM]: 'Pacific/Guam',
  [AllowedTimezone.PACIFIC_HONOLULU]: 'Pacific/Honolulu',
  [AllowedTimezone.PACIFIC_KANTON]: 'Pacific/Kanton',
  [AllowedTimezone.PACIFIC_KIRITIMATI]: 'Pacific/Kiritimati',
  [AllowedTimezone.PACIFIC_KOSRAE]: 'Pacific/Kosrae',
  [AllowedTimezone.PACIFIC_KWAJALEIN]: 'Pacific/Kwajalein',
  [AllowedTimezone.PACIFIC_MAJURO]: 'Pacific/Majuro',
  [AllowedTimezone.PACIFIC_MARQUESAS]: 'Pacific/Marquesas',
  [AllowedTimezone.PACIFIC_MIDWAY]: 'Pacific/Midway',
  [AllowedTimezone.PACIFIC_NAURU]: 'Pacific/Nauru',
  [AllowedTimezone.PACIFIC_NIUE]: 'Pacific/Niue',
  [AllowedTimezone.PACIFIC_NORFOLK]: 'Pacific/Norfolk',
  [AllowedTimezone.PACIFIC_NOUMEA]: 'Pacific/Noumea',
  [AllowedTimezone.PACIFIC_PAGO_PAGO]: 'Pacific/Pago_Pago',
  [AllowedTimezone.PACIFIC_PALAU]: 'Pacific/Palau',
  [AllowedTimezone.PACIFIC_PITCAIRN]: 'Pacific/Pitcairn',
  [AllowedTimezone.PACIFIC_POHNPEI]: 'Pacific/Pohnpei',
  [AllowedTimezone.PACIFIC_PORT_MORESBY]: 'Pacific/Port_Moresby',
  [AllowedTimezone.PACIFIC_RAROTONGA]: 'Pacific/Rarotonga',
  [AllowedTimezone.PACIFIC_SAIPAN]: 'Pacific/Saipan',
  [AllowedTimezone.PACIFIC_TAHITI]: 'Pacific/Tahiti',
  [AllowedTimezone.PACIFIC_TARAWA]: 'Pacific/Tarawa',
  [AllowedTimezone.PACIFIC_TONGATAPU]: 'Pacific/Tongatapu',
  [AllowedTimezone.PACIFIC_WAKE]: 'Pacific/Wake',
  [AllowedTimezone.PACIFIC_WALLIS]: 'Pacific/Wallis',
};
